/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["esSizeAdvisorJsonp"];
/******/ 	window["esSizeAdvisorJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		10: 0,
/******/ 		9: 0,
/******/ 		11: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "chunks/easysize." + {"0":"1b423e68708038fade75","1":"e051dde72a7ee74b466a","2":"0d57102c4954590cd28f","3":"88230a20a0335bf48877","4":"0fb986bd6bf2048469f2","5":"a8fe2de319e272294e97","7":"e57058aafd8855964f53"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://webapp.easysize.me/dist/js/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 22);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQaAdvisorLink = getQaAdvisorLink;
exports.startQaAdvisor = startQaAdvisor;
exports.embed = embed;
exports.closeQaAdvisor = closeQaAdvisor;
exports.addSizeRecommendedText = addSizeRecommendedText;

var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _jsCookie = __webpack_require__(6);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _utilities = __webpack_require__(2);

var _features = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languages = {
  'abkhaz': 'ab',
  'afar': 'aa',
  'afrikaans': 'af',
  'akan': 'ak',
  'albanian': 'sq',
  'amharic': 'am',
  'arabic': 'ar',
  'aragonese': 'an',
  'armenian': 'hy',
  'assamese': 'as',
  'avaric': 'av',
  'avestan': 'ae',
  'aymara': 'ay',
  'azerbaijani': 'az',
  'bambara': 'bm',
  'bashkir': 'ba',
  'basque': 'eu',
  'belarusian': 'be',
  'bengali': 'bn',
  'bihari': 'bh',
  'bislama': 'bi',
  'bosnian': 'bs',
  'breton': 'br',
  'bulgarian': 'bg',
  'burmese': 'my',
  'catalan; valencian': 'ca',
  'chamorro': 'ch',
  'chechen': 'ce',
  'chichewa; chewa; nyanja': 'ny',
  'chinese': 'zh',
  'chuvash': 'cv',
  'cornish': 'kw',
  'corsican': 'co',
  'cree': 'cr',
  'croatian': 'hr',
  'czech': 'cs',
  'danish': 'da',
  'divehi; dhivehi; maldivian;': 'dv',
  'dutch': 'nl',
  'english': 'en',
  'esperanto': 'eo',
  'estonian': 'et',
  'ewe': 'ee',
  'faroese': 'fo',
  'fijian': 'fj',
  'finnish': 'fi',
  'french': 'fr',
  'fula; fulah; pulaar; pular': 'ff',
  'galician': 'gl',
  'georgian': 'ka',
  'german': 'de',
  'greek, modern': 'el',
  'guaraní': 'gn',
  'gujarati': 'gu',
  'haitian; haitian creole': 'ht',
  'hausa': 'ha',
  'hebrew (modern)': 'he',
  'hebrew': 'he',
  'herero': 'hz',
  'hindi': 'hi',
  'hiri motu': 'ho',
  'hungarian': 'hu',
  'interlingua': 'ia',
  'indonesian': 'id',
  'interlingue': 'ie',
  'irish': 'ga',
  'igbo': 'ig',
  'inupiaq': 'ik',
  'ido': 'io',
  'icelandic': 'is',
  'italian': 'it',
  'inuktitut': 'iu',
  'japanese': 'ja',
  'javanese': 'jv',
  'kalaallisut, greenlandic': 'kl',
  'kannada': 'kn',
  'kanuri': 'kr',
  'kashmiri': 'ks',
  'kazakh': 'kk',
  'khmer': 'km',
  'kikuyu, gikuyu': 'ki',
  'kinyarwanda': 'rw',
  'kirghiz, kyrgyz': 'ky',
  'komi': 'kv',
  'kongo': 'kg',
  'korean': 'ko',
  'kurdish': 'ku',
  'kwanyama, kuanyama': 'kj',
  'latin': 'la',
  'luxembourgish, letzeburgesch': 'lb',
  'luganda': 'lg',
  'limburgish, limburgan, limburger': 'li',
  'lingala': 'ln',
  'lao': 'lo',
  'lithuanian': 'lt',
  'luba-katanga': 'lu',
  'latvian': 'lv',
  'manx': 'gv',
  'macedonian': 'mk',
  'malagasy': 'mg',
  'malay': 'ms',
  'malayalam': 'ml',
  'maltese': 'mt',
  'māori': 'mi',
  'marathi (marāṭhī)': 'mr',
  'marshallese': 'mh',
  'mongolian': 'mn',
  'nauru': 'na',
  'navajo, navaho': 'nv',
  'norwegian bokmål': 'nb',
  'north ndebele': 'nd',
  'nepali': 'ne',
  'ndonga': 'ng',
  'norwegian nynorsk': 'nn',
  'norwegian': 'no',
  'nuosu': 'ii',
  'south ndebele': 'nr',
  'occitan': 'oc',
  'ojibwe, ojibwa': 'oj',
  'old church slavonic, church slavic, church slavonic, old bulgarian, old slavonic': 'cu',
  'oromo': 'om',
  'oriya': 'or',
  'ossetian, ossetic': 'os',
  'panjabi, punjabi': 'pa',
  'pāli': 'pi',
  'persian': 'fa',
  'polish': 'pl',
  'pashto, pushto': 'ps',
  'portuguese': 'pt',
  'quechua': 'qu',
  'romansh': 'rm',
  'kirundi': 'rn',
  'romanian': 'ro',
  'russian': 'ru',
  'sanskrit (saṁskṛta)': 'sa',
  'sardinian': 'sc',
  'sindhi': 'sd',
  // 'northern sami': 'se',
  'samoan': 'sm',
  'sango': 'sg',
  'serbian': 'sr',
  'scottish gaelic; gaelic': 'gd',
  'shona': 'sn',
  'sinhala, sinhalese': 'si',
  'slovak': 'sk',
  'slovene': 'sl',
  'somali': 'so',
  'southern sotho': 'st',
  'spanish; castilian': 'es',
  'sundanese': 'su',
  'swahili': 'sw',
  'swati': 'ss',
  'swedish': 'sv',
  'tamil': 'ta',
  'telugu': 'te',
  'tajik': 'tg',
  'thai': 'th',
  'tigrinya': 'ti',
  'tibetan standard, tibetan, central': 'bo',
  'turkmen': 'tk',
  'tagalog': 'tl',
  'tswana': 'tn',
  'tonga (tonga islands)': 'to',
  'turkish': 'tr',
  'tsonga': 'ts',
  'tatar': 'tt',
  'twi': 'tw',
  'tahitian': 'ty',
  'uighur, uyghur': 'ug',
  'ukrainian': 'uk',
  'urdu': 'ur',
  'uzbek': 'uz',
  'venda': 've',
  'vietnamese': 'vi',
  'volapük': 'vo',
  'walloon': 'wa',
  'welsh': 'cy',
  'wolof': 'wo',
  'western frisian': 'fy',
  'xhosa': 'xh',
  'yiddish': 'yi',
  'yoruba': 'yo',
  'zhuang, chuang': 'za'
};

function getQaAdvisorLink(params) {
  var url = params.easysize.qa_widget_url;
  var language = 'en';

  if (languages.hasOwnProperty(params.shop.language)) {
    language = languages[params.shop.language];
  }

  var widget_url = '' + url + language + '/' + params.shop.generated_shop_id + '?' +
  // 'css='+cps+
  'product_brand_id=' + params.product.brand_id + '&product_fit_id=' + encodeURIComponent(params.product.fit_id) + '&product_type_id=' + params.product.category_id + '&product_id=' + params.product.id + '&product_brand=' + encodeURIComponent(params.product.brand) + '&product_type=' + encodeURIComponent(params.product.category) + '&product_gender=' + params.product.gender + '&product_model=' + encodeURIComponent(params.product.model) + '&product_fit=' + encodeURIComponent(params.product.fit) + '&available_fits=' + encodeURIComponent(params.product.available_fits) + '&available_lengths=' + encodeURIComponent(params.product.available_lengths) + '&selected_options=' + encodeURIComponent(params.product.selected_options) + '&product_sku=' + encodeURIComponent(params.product.sku) + '&product_url=' + encodeURIComponent(window.location.href) + '&sizes_in_stock=' + encodeURIComponent(JSON.stringify(params.product.stock)) + '&product_tags=' + encodeURIComponent(JSON.stringify(params.product.tags)) + '&fits_in_stock=' + encodeURIComponent(JSON.stringify(params.product.fits_in_stock)) + '&product_title=' + encodeURIComponent(params.product.title) + '&language=' + params.shop.language + '&session_id=' + params.easysize.pageview_id + '&origin_url=' + encodeURIComponent(document.URL) + '&easysize_user_id=' + params.easysize.user_id + '&api_url=' + encodeURIComponent(params.easysize.api_url) + '&product_type_english=' + encodeURIComponent(params.product.category_title) + '&product_type_article=' + encodeURIComponent(params.product.category_article) + '&product_type_gender=' + encodeURIComponent(params.product.category_gender) + '&product_type_collective_noun=' + encodeURIComponent(params.product.category_collective_noun) + '&product_image=' + encodeURIComponent(params.product.image_url) + '&custom_css=' + encodeURIComponent(params.shop.custom_css) + '&esnt=' + _jsCookie2.default.get('esnt');

  if (params.shop.size_guide_url) {
    widget_url += '&size_guide_url=' + params.shop.size_guide_url;
  }

  if (params.product.subcategory) {
    widget_url += '&p_subcategory=' + params.product.subcategory;
  }
  return widget_url;
}

function startQaAdvisor(params, page) {
  if (params.easysize.opened) return;

  params.easysize.opened = true; // mark easysize as opened
  document.body.classList.add('es-qa-advisor-open');

  if (document.getElementById('es-mobile-no-zoom')) {
    document.getElementById('es-mobile-no-zoom').setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
  } else {
    var meta = document.createElement('meta');
    meta.id = 'es-mobile-no-zoom';
    meta.setAttribute('name', 'viewport');
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    document.head.appendChild(meta);
  }

  var popup = void 0,
      iframe = void 0,
      img = void 0;

  popup = document.createElement('div');
  popup.id = 'es-background';
  popup.style.background = 'rgba(0, 0, 0, 0.6)';
  popup.style.position = 'fixed';
  popup.style.top = '0';
  popup.style.left = '0';
  popup.style.width = '100%';
  popup.style.height = '100%';
  popup.style.zIndex = '2147483646';

  // Create iframe
  iframe = document.createElement('iframe');
  Object.keys(params.easysize.widget_iframe_attributes).forEach(function (attr) {
    iframe.setAttribute(attr, params.easysize.widget_iframe_attributes[attr]);
  });

  iframe.id = 'easysize_popup';
  iframe.src = getQaAdvisorLink(params);

  if (page) {
    delete params.easysize.original_calculated_size.better_matches;
    iframe.src = iframe.src + '&page=' + page + '&calculated_size=' + JSON.stringify(params.easysize.original_calculated_size);
  }

  iframe.style.border = 0;
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.className = 'hidden';

  // Create img for nice UX
  img = document.createElement('img');
  img.src = 'https://webapp.easysize.me/web_app_v1.0/icons/ajax-loader.svg';
  img.style.position = 'fixed';
  img.style.width = '40px';
  img.style.height = 'auto';
  img.style.top = '40%';
  img.style.right = '0';
  img.style.left = '0';
  img.style.margin = '0 auto';

  popup.appendChild(img);

  iframe.onload = function () {
    popup.removeChild(img);
    iframe.className = '';
    iframe.focus();
  };

  popup.appendChild(iframe); // append iframe to popup
  document.body.appendChild(popup); // append popup to DOM

  window.postMessage(JSON.stringify({
    'easysize_tracking': true,
    'action': 2
  }), '*');
}

function embed(params, page) {
  var iframe = document.createElement('iframe');
  Object.keys(params.easysize.widget_iframe_attributes).forEach(function (attr) {
    iframe.setAttribute(attr, params.easysize.widget_iframe_attributes[attr]);
  });

  iframe.id = 'easysize_popup';
  iframe.src = getQaAdvisorLink(params) + '&embedded=1';

  iframe.style.border = 0;
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.className = 'easysize-embed-iframe';

  Array.from(document.querySelectorAll('.easysize-embed')).forEach(function (i) {
    i.innerHTML = '';
    i.appendChild(iframe);
  });
}

function closeQaAdvisor(params) {
  (0, _utilities.debug)('[EasySize] Closing qa advisor');

  window.postMessage(JSON.stringify({
    'easysize_tracking': true,
    'action': 9
  }), '*');

  params.easysize.opened = false;
  document.body.classList.remove('es-qa-advisor-open');

  if (document.getElementById('es-mobile-no-zoom') && params.shop.current_meta_viewport) {
    document.getElementById('es-mobile-no-zoom').setAttribute('content', params.shop.current_meta_viewport);
  }

  if (!document.getElementById('es-background')) {
    return;
  }
  // Fade out the popup
  var fadeTarget = document.getElementById('es-background');

  if (!fadeTarget.style.opacity) {
    fadeTarget.style.opacity = 1;
  }

  for (var i = 1; i < 11; i++) {
    (function (i) {
      setTimeout(function () {
        fadeTarget.style.opacity -= 0.1;
        if (i === 10) {
          fadeTarget.style.display = 'none';
        }
      }, i * 20);
    })(i);
  }

  setTimeout(function () {
    try {
      document.body.removeChild(document.getElementById('es-background'));
    } catch (e) {}
  }, 2000);
}

function addSizeRecommendedText(className, text, appendBody, params) {
  if (!params.easysize.dom_updates) {
    (0, _utilities.debug)('Easysize turned off addSizeRecommendedText');
    return;
  }

  (0, _utilities.debug)('sa-qa addSizeRecommendedText');
  // easysize_tracking_initiated
  if (params.easysize.pageview_id === -1) {
    (0, _utilities.subscribe)('easysize_tracking_initiated', function () {
      addSizeRecommendedText(className, text, appendBody, params);
    });
  } else if (!params.button.loaded_from_server) {
    setTimeout(function () {
      addSizeRecommendedText(className, text, appendBody, params);
    }, 100);
  } else {
    (0, _utilities.removeElementsByClassName)('es-selected');
    (0, _utilities.removeElementsByClassName)('es-recommended');

    var rtext = document.createElement('p');
    rtext.className = className;
    rtext.innerHTML = params.button[text].replace('{n}', params.easysize.calculated_size_proven_by);
    rtext.tabIndex = 0;
    rtext.role = 'button';
    rtext.onclick = function () {
      startQaAdvisor(params);
    };

    var recommended_size = params.easysize.calculated_size;

    // Append recommended length to size prediction if available
    try {
      if (params.easysize.original_calculated_size.recommended_length && params.product.available_lengths.indexOf(params.easysize.original_calculated_size.recommended_length) !== -1) {
        recommended_size = params.easysize.calculated_size + ' / ' + params.easysize.original_calculated_size.recommended_length;
      }
    } catch (e) {
      (0, _utilities.debug)(e);
    }

    if (params.easysize.hasOwnProperty('recommended_fit')) {
      if (params.easysize.recommended_fit && params.easysize.recommended_fit !== '*' && params.product.available_fits.indexOf(params.easysize.recommended_fit) !== -1) {
        if (rtext.innerHTML.indexOf('{recommended_fit}') !== -1) {
          rtext.innerHTML = rtext.innerHTML.replace('{recommended_fit}', params.easysize.recommended_fit);
        } else if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
          // If recommended_fit exists but it's not part of the text, append it at the end
          rtext.innerHTML = rtext.innerHTML.replace('{s}', '{s} / ' + params.easysize.recommended_fit);
        }
      } else {
        if (params.features.hasOwnProperty('append_size_with_recommended_fit_fallback')) {
          // fallback to provided text if fit does not exist
          rtext.innerHTML = params.features.append_size_with_recommended_fit_fallback;
        }
      }
      rtext.innerHTML = rtext.innerHTML.replace('{s}', recommended_size);
    } else if (params.features.hasOwnProperty('append_size_with_recommended_fit_fallback')) {
      // fallback to provided text if fit does not exist
      rtext.innerHTML = params.features.append_size_with_recommended_fit_fallback;
    }

    var recommended_fit = params.easysize.original_calculated_size.recommended_fit;
    var fit_tags = ['f', 'fit', 'recommended_fit'];
    if (recommended_fit && params.product.available_fits.indexOf(recommended_fit) !== -1) {
      fit_tags.forEach(function (tag) {
        rtext.innerHTML = rtext.innerHTML.replace('{' + tag + '}', recommended_fit);
      });
    }

    // hardcoded fallback of recommended fit
    var hardcoded_fit_fallbacks = ['in {tag}', 'in {tag} fit', ' / <i>{tag}</i>', '{tag}'];
    fit_tags.forEach(function (tag) {
      hardcoded_fit_fallbacks.forEach(function (hardcoded_fallback) {
        var fallback = hardcoded_fallback.replace('{tag}', '{' + tag + '}');
        rtext.innerHTML = rtext.innerHTML.replace(fallback, '');
      });
    });

    rtext.innerHTML = rtext.innerHTML.replace('{s}', recommended_size);

    // Add extra elements if any added
    if (params.elements.extra && params.elements.extra.size_selector) {
      for (var i = 0; i < params.elements.extra.size_selector.length; i++) {
        var el = (0, _qwery2.default)(params.elements.extra.size_selector[i])[0];

        if (el) {
          el.parentNode.insertBefore(rtext.cloneNode(true), el.nextSibling);
        }
      }
    }

    // Append after size selector
    try {
      if (params.shop.recommendation_placeholder) {
        (0, _qwery2.default)(params.shop.recommendation_placeholder)[0].appendChild(rtext);
      } else if (params.elements.size_dropdown) {
        var placeholder = params.elements.size_dropdown;
        if (params.elements.extra.hasOwnProperty('returning_user_text_placeholder')) {
          placeholder = (0, _qwery2.default)(params.elements.extra.returning_user_text_placeholder[0])[0];

          if (!placeholder) {
            placeholder = params.elements.size_dropdown;
          }
        }

        try {
          placeholder[params.elements.button_r_position](rtext);
        } catch (e) {
          (0, _utilities.debug)('[EasySize] Issue adding returning user message', e);
          placeholder.parentNode.insertBefore(rtext, placeholder.nextSibling);
        }
      } else {
        params.elements.button_placeholder.appendChild(rtext);
      }
    } catch (e) {
      (0, _utilities.debug)('[EasySize] Issue appending returning user message');
    }

    var es_placeholder = (0, _qwery2.default)(params.shop.recommendation_placeholder)[0] || params.elements.size_dropdown || (0, _qwery2.default)(params.shop.size_dropdown_selector)[0];
    if (!es_placeholder || !(0, _features.elementVisible)(es_placeholder)) {
      es_placeholder = (0, _features.predictPlaceholders)(params) || es_placeholder;
    }

    try {
      if (es_placeholder) {
        es_placeholder[params.elements.button_r_position](rtext);
      } else {
        setTimeout(function () {
          (0, _utilities.debug)('[EasySize] Returning user placeholder doesnt exist, trying again');
          addSizeRecommendedText(className, text, appendBody, params);
        }, 50);
      }
    } catch (e) {
      (0, _utilities.debug)('[EasySize] Issue adding returning user message', e);
      es_placeholder.parentNode.insertBefore(rtext, es_placeholder.nextSibling);
    }

    document.body.classList.add(appendBody);
    window.dispatchEvent(new CustomEvent('easysize_loaded__returning', {
      detail: {
        recommended_size: params.easysize.original_calculated_size.size
      }
    }));
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitter = undefined;
exports.findGender = findGender;
exports.enableEasySizeFeatures = enableEasySizeFeatures;
exports.elementVisible = elementVisible;
exports.predictPlaceholders = predictPlaceholders;
exports.loadEasySizeButton = loadEasySizeButton;
exports.setLanguage = setLanguage;
exports.loadEasySizeStyle = loadEasySizeStyle;
exports.updateSize = updateSize;
exports.updateSizeVP = updateSizeVP;
exports.applyExperiments = applyExperiments;
exports.checkProduct = checkProduct;
exports.bindEasysizeMessages = bindEasysizeMessages;

var _reqwest = __webpack_require__(11);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _bean = __webpack_require__(7);

var _bean2 = _interopRequireDefault(_bean);

var _jsCookie = __webpack_require__(6);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _tracking = __webpack_require__(12);

var _utilities = __webpack_require__(2);

var _domUtilities = __webpack_require__(18);

var _selectSize = __webpack_require__(19);

var _sizeInsights = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = __webpack_require__(21).eventHandler(); /* eslint-disable camelcase */

exports.emitter = emitter;


var male_list = ['man', 'm', 'men', 'boy', 'boys', 'him', 'male', 'homme', 'mens'];
var female_list = ['woman', 'women', 'f', 'girl', 'girls', 'her', 'female', 'femme', 'womens', 'dame', 'kvinde'];

function findGender(gender) {
  if (gender) {
    return male_list.indexOf(gender.toLowerCase()) !== -1 ? 'male' : female_list.indexOf(gender.toLowerCase()) !== -1 ? 'female' : gender;
  } else {
    return gender;
  }
}

function enableEasySizeFeatures(params) {
  if (!params.easysize.dom_updates) {
    (0, _utilities.debug)('Easysize turned off enableEasySizeFeatures');
    window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: true } }));
    if (params.easysize.loaded) {
      params.easysize.loaded({
        is_product_supported: true
      }, false);
    }
    return;
  }

  loadEasySizeButton(params);
  if (params.features.size_advice_qa) {
    _bean2.default.on(document, 'click', '.easysize_button', function () {
      new Promise(function(resolve) { resolve(); }).then((function (require) {
        __webpack_require__(0).startQaAdvisor(params);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    });

    _bean2.default.on(document, 'click', '.easysize-widget', function () {
      new Promise(function(resolve) { resolve(); }).then((function (require) {
        __webpack_require__(0).startQaAdvisor(params);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    });

    // Bean.on(document, 'click', '.easysize_button__returning', () => {
    //   require.ensure('./size-advisor-qa', (require) => {
    //     require('./size-advisor-qa').startQaAdvisor(params, 'returning')
    //   })
    // })

    // Bean.on(document, 'click', '.easysize_button__out_of_stock', () => {
    //   require.ensure('./size-advisor-qa', (require) => {
    //     require('./size-advisor-qa').startQaAdvisor(params, 'out-of-stock-no-recommendation')
    //   })
    // })

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        if (e.target.matches('.easysize_button') || e.target.matches('.easysize_button')) {
          __webpack_require__(0).startQaAdvisor(params);
        }
        if (e.target.matches('.easysize_button__returning') || e.target.matches('.easysize_button__out_of_stock') || e.target.matches('.es-recommended')) {
          __webpack_require__(0).startQaAdvisor(params, 'returning');
        }
      }
    });
  }
}

function elementVisible(selector) {
  // We element exists and is visible, return true
  // If selector is stirng, assume it's selector, otherwise see it as element
  var element = typeof selector === 'string' ? document.querySelector(selector) : selector;
  if (element) {
    if (element.checkVisibility) {
      return element.checkVisibility();
    } else {
      return true;
    }
  }
  return false;
}

function PredictGloboSwatch() {
  EasySizeParametersDebug.shop.prediction = 'globo-swatch';
  EasySizeParametersDebug.shop.size_dropdown_selector = '.globo-swatch-product-detail';
  EasySizeParametersDebug.shop.easysize_button_placeholder_selector = '.globo-swatch-product-detail';
  EasySizeParametersDebug.shop.update_size_dropdown = function (size) {
    var size_element = document.querySelector('.globo-swatch-product-detail [value="' + size + '"]');
    if (size_element) {
      size_element.click();
      EasySizeParametersDebug.shop.original_size_update_function(size);
      return true;
    }
    return params.shop.original_size_update_function(size);
  };

  if (window.easy_size) {
    setTimeout(window.easy_size.refresh, 100);
  }
}

function predictPlaceholders(params) {
  var es_placeholder = false;
  window.removeEventListener('Globo.swatch.loaded', PredictGloboSwatch);

  if (params.button.predict) {
    window.addEventListener('Globo.swatch.loaded', PredictGloboSwatch);
    // Predict variant swatch king. 
    if (window.VariantSwatchKing) {
      params.shop.prediction = 'variant-swatch-king';
      params.shop.size_dropdown_selector = 'variant-swatch-king';
      params.shop.easysize_button_placeholder_selector = 'variant-swatch-king';
      es_placeholder = document.querySelector('variant-swatch-king');

      return es_placeholder;
    }

    // Predict globbo
    if (!es_placeholder && elementVisible('.globo-swatch-product-detail')) {
      params.shop.prediction = 'globo-swatch';
      params.shop.size_dropdown_selector = '.globo-swatch-product-detail';
      params.shop.easysize_button_placeholder_selector = '.globo-swatch-product-detail';
      es_placeholder = document.querySelector('.globo-swatch-product-detail');

      return es_placeholder;
    }

    // Predict variant-selects
    if (!es_placeholder && elementVisible('variant-selects')) {
      params.shop.prediction = 'variant-selects';
      params.shop.size_dropdown_selector = 'variant-selects';
      params.shop.easysize_button_placeholder_selector = 'variant-selects';
      es_placeholder = document.querySelector('variant-selects');

      return es_placeholder;
    }

    // Predict Groupify / mpg-swatch
    if (!es_placeholder && elementVisible('.mpg-swatch')) {
      params.shop.prediction = 'groupify';
      params.shop.size_dropdown_selector = '.mpg-swatch';
      params.shop.easysize_button_placeholder_selector = '.mpg-swatch';
      es_placeholder = document.querySelector('.mpg-swatch');

      return es_placeholder;
    }

    // Predict product-variants
    if (!es_placeholder && elementVisible('product-variants')) {
      params.shop.prediction = 'product-variants';
      params.shop.size_dropdown_selector = 'product-variants';
      params.shop.easysize_button_placeholder_selector = 'product-variants';
      es_placeholder = document.querySelector('product-variants');

      return es_placeholder;
    }

    // Predict variant-picker
    if (!es_placeholder && elementVisible('variant-picker')) {
      params.shop.prediction = 'variant-picker';
      params.shop.size_dropdown_selector = 'variant-picker';
      params.shop.easysize_button_placeholder_selector = 'variant-picker';
      es_placeholder = document.querySelector('variant-picker');

      return es_placeholder;
    }
  }

  return false;
}

var prediction_counter = 0;
function loadEasySizeButton(params) {
  var btn = document.createElement('div');

  if (!document.getElementById('easysize_button')) {
    // Create easysize button and place it after placeholder
    btn.id = 'easysize_button';
    btn.className = 'easysize_button';
    btn.innerHTML = params.button.primary_text;
    btn.tabIndex = 0;
    btn.role = 'button';
    // btn.setAttribute('data-first', params.button.primary_text)
    // btn.setAttribute('data-second', params.button.secondary_text)
    // btn.dataset.first = params.button.primary_text;
    // btn.dataset.second = params.button.secondary_text;

    if (params.shop.easysize_button_placeholder_selector.constructor === Array) {
      for (var i = 0; i < params.shop.easysize_button_placeholder_selector.length; i++) {
        var es_placeholder = (0, _qwery2.default)(params.shop.easysize_button_placeholder_selector[i])[0];
        if (!es_placeholder) {
          continue;
        }

        try {
          es_placeholder[params.elements.button_n_position](btn);
        } catch (e) {
          // Legacy new button add
          (0, _utilities.debug)('[EasySize] Issue adding new user message', e);
          if (es_placeholder && es_placeholder.nextSibling && es_placeholder.nextSibling.id === 'es-recommended') {
            es_placeholder.parentNode.insertBefore(btn, es_placeholder.nextSibling.nextSibling);
          } else {
            es_placeholder.parentNode.insertBefore(btn, es_placeholder.nextSibling);
          }
        }
      }
    } else {
      // If placeholder not found, we delay the button appearance. We also try to predict additional placeholders
      var _es_placeholder = false;

      if ((0, _qwery2.default)(params.shop.easysize_button_placeholder_selector)[0]) {
        params.shop.prediction = 'original';
        _es_placeholder = (0, _qwery2.default)(params.shop.easysize_button_placeholder_selector)[0];
      }

      // Only predict if it's our predictor es_placeholder
      if (!_es_placeholder && params.shop.size_dropdown_selector == '.es_placeholder') {
        _es_placeholder = predictPlaceholders(params);
      }

      // Fallback to easysize container
      if (!_es_placeholder && prediction_counter == 1) {
        params.shop.prediction = '.easysize-container';
        params.shop.size_dropdown_selector = '.easysize-container';
        params.shop.easysize_button_placeholder_selector = '.easysize-container';
        _es_placeholder = document.querySelector('.easysize-container');
      }

      if (!_es_placeholder) {
        prediction_counter++;
        (0, _utilities.debug)('[EasySize debug]: Placeholder not found, delaying the button appearance');
        setTimeout(function () {
          loadEasySizeButton(params);
        }, 500);
        return false;
      }

      try {
        _es_placeholder[params.elements.button_n_position](btn);
      } catch (e) {
        // Legacy new button add
        (0, _utilities.debug)('[EasySize] Issue adding new user message', e);
        if (_es_placeholder && _es_placeholder.nextSibling && _es_placeholder.nextSibling.id === 'es-recommended') {
          _es_placeholder.parentNode.insertBefore(btn, _es_placeholder.nextSibling.nextSibling);
        } else {
          _es_placeholder.parentNode.insertBefore(btn, _es_placeholder.nextSibling);
        }
      }
    }

    if (params.experiment.button_html) {
      btn.outerHTML = params.experiment.button_html;
    }
  }

  btn = document.getElementById('easysize_button');

  try {
    document.body.classList.add('es-loaded');
  } catch (e) {}
  window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: true } }));
  if (params.easysize.loaded) {
    params.easysize.loaded({
      is_product_supported: true
    }, false);
  }

  params.elements.easysize_button = btn;

  if (!_jsCookie2.default.get('easysize_button_loaded_for_user')) {
    document.body.classList.add('easysize_new_user_infotip');
    _jsCookie2.default.set('easysize_button_loaded_for_user', 1, Infinity, '/');
  }
}

function setLanguage(params, language) {
  // Update language
  params.shop.language = (0, _utilities.getLanguage)(language).language;

  var shop = '';
  if (window.Shopify && window.Shopify.shop) {
    shop = window.Shopify.shop;
  }

  // Fetch button texts
  (0, _reqwest2.default)({
    method: 'GET',
    url: params.easysize.tracking_url + 'shop/config',
    data: {
      shop_id: params.shop.generated_shop_id,
      language: params.shop.language,
      shop: shop
    },
    error: function error(resp) {
      (0, _utilities.debug)('[EasySize debug]: Error getting easysize styles');
    },
    success: function success(resp) {
      // resp = JSON.parse(resp)
      if (resp.style && params.easysize.dom_updates) {
        var a = document.createElement('link');
        a.type = 'text/css';
        a.rel = 'stylesheet';
        a.href = 'https://webapp.easysize.me/web_app_v1.0/stylesheets/' + resp.style;
        // a.href = "/easysize/library/stylesheets/"+resp.style;
        document.body.appendChild(a);
      } else {
        (0, _utilities.debug)('Easysize turned off loadEasySizeStyle');
      }

      if (resp.placeholder) {
        params.shop.easysize_button_placeholder_selector = resp.placeholder;
      }

      params.button.primary_text = params.shop.new_user_text || resp.text.button_text;
      params.button.returning_user_text = params.shop.returning_user_text || resp.text.returning_user;
      params.button.returning_user_text_out_of_stock = params.shop.returning_user_text || resp.text.returning_user_out_of_stock;
      params.button.recommended_size_text = params.shop.returning_user_text || resp.text.size_selected;

      // Remove and reload all buttons
      (0, _utilities.removeElementsByClassName)('es-selected');
      (0, _utilities.removeElementsByClassName)('es-recommended');
      (0, _utilities.removeElementsByClassName)('easysize_button');

      if (params.product.brand_id) {
        loadEasySizeButton(params);
        if (params.easysize.calculated_size) {
          emitter.emit('easysize-size-selected');
        }
      }
    }
  });
}

function loadEasySizeStyle(params) {
  // This is based on product_feedback.languages table
  try {
    var page_language = (0, _utilities.getLanguage)(document.querySelector('html').getAttribute('lang'));
    if (page_language) {
      params.shop.language = page_language.language;
    }

    // Monkey patch for Transcy AI translator to correctly pick up the page language
    if (window._transcy && window._transcy.variants && window._transcy.variants.localeCurrent) {
      var transcy_language = window._transcy.variants.localeCurrent;
      params.shop.language = (0, _utilities.getLanguage)(transcy_language).language;
    }
  } catch (e) {
    (0, _utilities.debug)('Unable to automatically recognise language');
  }

  var shop = '';
  if (window.Shopify && window.Shopify.shop) {
    shop = window.Shopify.shop;
  }

  (0, _reqwest2.default)({
    method: 'GET',
    url: params.easysize.tracking_url + 'shop/config',
    data: {
      shop_id: params.shop.generated_shop_id,
      language: params.shop.language,
      shop: shop
    },
    error: function error(resp) {
      (0, _utilities.debug)('[EasySize debug]: Error getting easysize styles');
    },
    success: function success(resp) {
      // resp = JSON.parse(resp)
      if (resp.style && params.easysize.dom_updates) {
        var a = document.createElement('link');
        a.type = 'text/css';
        a.rel = 'stylesheet';
        a.href = 'https://webapp.easysize.me/web_app_v1.0/stylesheets/' + resp.style;
        // a.href = "/easysize/library/stylesheets/"+resp.style;
        document.body.appendChild(a);
      } else {
        (0, _utilities.debug)('Easysize turned off loadEasySizeStyle');
      }

      if (resp.placeholder) {
        params.shop.easysize_button_placeholder_selector = resp.placeholder;
      }

      params.elements.extra = {};
      if (resp.hasOwnProperty('elements')) {
        var elements = resp.elements;
        for (var element in elements) {
          params.elements.extra[element] = elements[element];
        }
      }

      if (resp.hasOwnProperty('features')) {
        params.features = Object.assign(params.features, resp.features);

        if (params.features.hasOwnProperty('custom_css')) {
          document.head.insertAdjacentHTML('beforeend', '<style>' + params.features.custom_css + '</style>');
        }

        if (params.features.hasOwnProperty('custom_css_advanced')) {
          document.head.insertAdjacentHTML('beforeend', '<style>' + params.features.custom_css_advanced + '</style>');
        }

        if (params.features.hasOwnProperty('shopify_cart_fix')) {
          document.addEventListener('click', function (e) {
            if (!e.target.matches(EasySizeParametersDebug.shop.add_to_cart_btn_selector)) return;
            setTimeout(function () {
              fetch(window.Shopify.routes.root + 'cart.js').then(function (response) {
                return response.json();
              }).then(function (data) {
                var item = data['items'][0];
                if (item) {
                  if (!item.properties) {
                    item.properties = {};
                  }

                  if (!item.properties.hasOwnProperty('_esid')) {
                    var properties = item.properties;
                    properties['_esid'] = EasySizeParametersDebug.easysize.pageview_id;
                    fetch(window.Shopify.routes.root + 'cart/change.js', {
                      method: 'POST',
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        'id': data['items'][0]['key'],
                        'properties': properties
                      })
                    });
                  }
                }
              });
            }, 1000);
          });
        }

        if (params.features.hasOwnProperty('size_insights_texts')) {
          (0, _utilities.debug)('Easysize exposing size insights');
          window.EasysizeSizeInsights = function (conf) {
            (0, _sizeInsights.createSizeInsights)(conf);
          };
        }
      }

      try {
        if (resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('gender')) {
          var tags = EasySizeParametersDebug.product.tags.map(function (tag) {
            return "[Tag] " + tag;
          });
          var is_male = resp.configuration.gender.male_mapping.filter(function (t) {
            return tags.includes(t);
          }).length;
          var is_female = resp.configuration.gender.female_mapping.filter(function (t) {
            return tags.includes(t);
          }).length;
          var is_unisex = resp.configuration.gender.unisex_mapping.filter(function (t) {
            return tags.includes(t);
          }).length;
          var product_gender = is_male ? "m" : is_female ? "f" : resp.configuration.gender.default_gender || 'u';
          if (is_male && is_female || is_unisex) {
            product_gender = 'u';
          }
          EasySizeParametersDebug.product.gender = product_gender;
        }
      } catch (e) {
        console.warn('[Easysize] Error configuring gender', e);
      }

      try {
        if (resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('shop_id')) {
          params.shop.generated_shop_id = resp.configuration.shop_id;
        }
      } catch (e) {
        console.warn('[Easysize] Error configuring shop id', e);
      }

      try {
        if (!params.product.brand && resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('brand')) {
          params.product.brand = resp.configuration.brand;
        }
      } catch (e) {
        console.warn('[Easysize] Error configuring brand', e);
      }

      try {
        // Shopify product variant to stock recognition
        if (resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('product_options') && resp.configuration.product_options.hasOwnProperty('size') && params.product.variants) {
          var size_option_titles = resp.configuration.product_options.size;
          var fit_option_titles = resp.configuration.product_options.fit;
          var length_option_titles = resp.configuration.product_options.length;
          var product_variants = params.product.variants;
          var product_options = params.product.options;
          var size_option_index = -1;
          var fit_option_index = -1;
          var length_option_index = -1;
          var sizes_in_stock = {};
          var available_fits = [];
          var available_lengths = [];

          for (var i = 0; i < product_options.length; i++) {
            // Find size option
            for (var y = 0; y < size_option_titles.length; y++) {
              if (product_options[i].toLowerCase().trim() === size_option_titles[y].toLowerCase()) {
                size_option_index = "option" + (i + 1);
                params.product.size_option_index = size_option_index;
                break;
              }
            }
            // Find fit option
            if (fit_option_titles) {
              for (var _y = 0; _y < fit_option_titles.length; _y++) {
                if (product_options[i].toLowerCase().trim() === fit_option_titles[_y].toLowerCase()) {
                  fit_option_index = "option" + (i + 1);
                  params.product.fit_option_index = fit_option_index;
                  break;
                }
              }
            }
            // Find length option
            if (length_option_titles) {
              for (var _y2 = 0; _y2 < length_option_titles.length; _y2++) {
                if (product_options[i].toLowerCase().trim() === length_option_titles[_y2].toLowerCase()) {
                  length_option_index = "option" + (i + 1);
                  params.product.length_option_index = length_option_index;
                  break;
                }
              }
            }
          }

          if (size_option_index === -1) {
            var found = false;
            for (var _i = 0; _i < product_options.length; _i++) {
              // If not found, try looking for size option inside isntead of exact match
              for (var _y3 = 0; _y3 < size_option_titles.length; _y3++) {
                if (product_options[_i].toLowerCase().trim().indexOf(size_option_titles[_y3].toLowerCase()) !== -1) {
                  found = true;
                  size_option_index = "option" + (_i + 1);
                  break;
                }
              }

              if (found) break;
            }
          }

          for (var _i2 = 0; _i2 < product_variants.length; _i2++) {
            var size = product_variants[_i2][size_option_index];
            var fit = product_variants[_i2][fit_option_index];
            var length = product_variants[_i2][length_option_index];
            var stock = product_variants[_i2].available ? 1 : 0;

            if (sizes_in_stock.hasOwnProperty(size)) {
              if (sizes_in_stock[size] < stock) {
                sizes_in_stock[size] = stock;
              }
            } else if (size) {
              sizes_in_stock[size] = stock;
            }

            if (fit && available_fits.indexOf(fit) === -1) {
              available_fits.push(fit);
            }
            if (length && available_lengths.indexOf(length) === -1) {
              available_lengths.push(length);
            }
          }

          if (Object.keys(sizes_in_stock).length > 0) {
            params.product.stock = sizes_in_stock;
          }
          if (available_fits.length > 0) {
            params.product.available_fits = available_fits;
          }
          if (available_lengths.length > 0) {
            params.product.available_lengths = available_lengths;
          }
        }
      } catch (e) {
        console.warn('[Easysize] Error configuring size options', e);
      }

      params.button.primary_text = params.shop.new_user_text || resp.text.button_text;
      params.button.returning_user_text = params.shop.returning_user_text || resp.text.returning_user;
      params.button.returning_user_text_out_of_stock = params.shop.returning_user_text || resp.text.returning_user_out_of_stock;
      params.button.recommended_size_text = params.shop.returning_user_text || resp.text.size_selected;
      params.button.loaded_from_server = true;
      params.easysize.product = params.features.size_advice_qa ? 'size-advisor-qa' : 'size-advisor';
      if (_jsCookie2.default.get('es_force_qa')) {
        params.easysize.product = 'size-advisor-qa';
        params.features.size_advice_qa = true;
      }

      try {
        if (window.location.search.indexOf('es_force_qa') !== -1) {
          _jsCookie2.default.set('es_force_qa', 1, Infinity, '/');
          params.features.size_advice_qa = true;
        }
      } catch (e) {}

      if (params.features.hasOwnProperty('custom_javascript')) {
        try {
          eval(params.features.custom_javascript);
        } catch (e) {
          console.warn('[Easysize] Error running custom_javascript', e);
        }
      }
    }
  });
}

function updateSize(size, params) {
  var options = (0, _qwery2.default)(params.shop.size_dropdown_selector + ' option').map(function (el) {
    return el.innerHTML;
  });
  var smart_size = (0, _selectSize.smartSizeSelection)(size, options);

  if (smart_size) {
    return (0, _domUtilities.selectOptionInSelect)(params.shop.size_dropdown_selector, smart_size, params);
  }

  return false;
}

function updateSizeVP(size, params) {
  var options = (0, _qwery2.default)(params.shop.size_dropdown_selector + ' option').map(function (el) {
    return el.innerHTML;
  });
  var smart_size = (0, _selectSize.smartSizeSelectionVP)(size, options);

  if (smart_size) {
    return (0, _domUtilities.selectOptionInSelect)(params.shop.size_dropdown_selector, smart_size, params);
  }

  return false;
}

function applyExperiments(data, params, callback) {
  if (data.experiment_translation_exist) {
    data.experiment_translation.forEach(function (el) {
      switch (el.name) {
        case 'button_text':
          params.button.primary_text = el.text;
          break;

        case 'returning_user':
          params.button.returning_user_text = el.text.replace('{n}', params.easysize.calculated_size_proven_by);
          setTimeout(function () {
            (0, _qwery2.default)('#es-recommended')[0].innerHTML = params.button.returning_user_text;
          }, 0);
          break;

        case 'size_selected':
          params.button.recommended_size_text = el.text;
          break;
      }
    });
  }

  if (data.experiment_exist) {
    if (data.experiment.hasOwnProperty('css')) {
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = 'https://webapp.easysize.me/web_app_v1.0/experiments/css/' + data.experiment.css;
      document.head.appendChild(link);
    }

    if (data.experiment.hasOwnProperty('template')) {
      (0, _reqwest2.default)({
        method: 'GET',
        url: 'https://webapp.easysize.me/web_app_v1.0/experiments/btn/' + data.experiment.template,
        contentType: 'text/html',
        success: function success(d) {
          params.experiment.button_html = d;
          callback();
        }
      });
    } else {
      callback();
    }
  } else {
    callback();
  }
}

function handle_cart_click(e) {
  if (e.type != 'easysize-add-to-cart') {
    if (!e.target.matches(EasySizeParametersDebug.shop.add_to_cart_btn_selector) && !e.target.parentNode.matches(EasySizeParametersDebug.shop.add_to_cart_btn_selector)) return;
  }

  try {
    try {
      var selected_size = EasySizeParametersDebug.shop.selected_size ? EasySizeParametersDebug.shop.selected_size : EasySizeParametersDebug.elements.size_dropdown.options[EasySizeParametersDebug.elements.size_dropdown.selectedIndex].text;
    } catch (e) {
      if (EasySizeParametersDebug.features.add_to_cart_value_fallback) {
        var selected_size = eval(EasySizeParametersDebug.features.add_to_cart_value_fallback);
      }

      if (EasySizeParametersDebug.easysize.calculated_size) {
        var selected_size = EasySizeParametersDebug.easysize.calculated_size;
      }
    }

    // Handle custom event, that might contain optional/recommended size parameter
    if (e.type == 'easysize-add-to-cart' && e.detail && e.detail.size) {
      selected_size = e.detail.size;
    }

    EasySizeParametersDebug.track(19, selected_size);

    if (EasySizeParametersDebug.features.add_to_cart) {
      __webpack_require__.e/* require.ensure */(3).then((function (require) {
        var saveUserItemToWardrobe = __webpack_require__(9).saveUserItemToWardrobe;
        var wardrobeParams = {
          item_gender: EasySizeParametersDebug.product.gender.substr(0, 1),
          item_brand: EasySizeParametersDebug.product.brand_id,
          item_product_type: EasySizeParametersDebug.product.category_id,
          item_size_raw: selected_size,
          source: 'C'
        };

        if (EasySizeParametersDebug.product.fit) {
          wardrobeParams['item_fit'] = EasySizeParametersDebug.product.fit;
        }

        if (EasySizeParametersDebug.product.model) {
          wardrobeParams['item_model'] = EasySizeParametersDebug.product.model;
        }

        saveUserItemToWardrobe(EasySizeParametersDebug, wardrobeParams);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  } catch (e) {
    console.warn(e);
  }
}

function handle_size_change(e) {
  try {
    var size = e.detail.size;
    emitter.emit('easysize_size_selected', size);
    params.shop.selected_size = size;
  } catch (e) {
    (0, _utilities.debug)('handle_size_change', e);
  }
}

function handle_set_language(e) {
  try {
    var language = e.detail.language;

    setLanguage(EasySizeParametersDebug, language);
  } catch (e) {
    (0, _utilities.debug)('handle_set_language', e);
  }
}

function checkProduct(params) {
  var form_data = {
    'product_types': JSON.stringify(params.product.category),
    'product_gender': params.product.gender,
    'product_brand': params.product.brand,
    'product_id': params.product.id,
    'qa_support': params.features.hasOwnProperty('size_advice_qa') ? params.features.size_advice_qa : false,
    'sizes_in_stock': JSON.stringify(params.product.stock)
  };

  if (params.product.fit) {
    form_data.product_fit = params.product.fit;
  }
  if (params.product.model) {
    form_data.product_model = params.product.model;
  }
  if (params.product.sku) {
    form_data.product_sku = params.product.sku;
  }

  (0, _reqwest2.default)({
    url: '' + params.easysize.api_url + params.shop.generated_shop_id + '/check_product/',
    method: 'GET',
    data: form_data,
    error: function error(resp) {
      (0, _utilities.debug)('[EasySize debug]: Error checking product');
    },
    success: function success(resp) {
      if (resp.status_code) {
        if (resp.error) {
          (0, _utilities.debug)('[EasySize debug]: EasySize check product failed with [' + resp.status_code + '] ' + resp.error);
          (0, _tracking.unsupportedProductTracking)(params);
          window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: false } }));
          if (params.easysize.loaded) {
            params.easysize.loaded({
              is_product_supported: false
            }, {
              'error': resp.error,
              'status_code': resp.status_code
            });
          }
        } else {
          (0, _utilities.debug)('[EasySize debug]: EasySize check product failed with [' + resp.status_code + ']');
          for (var err in resp) {
            if (err !== 'status_code') {
              (0, _utilities.debug)('[EasySize debug] Attribute "' + err + '" - ' + resp[err]);
            }
          }

          (0, _tracking.unsupportedProductTracking)(params);
          window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: false } }));
          if (params.easysize.loaded) {
            params.easysize.loaded({
              is_product_supported: false
            }, {
              'status_code': resp.status_code
            });
          }
        }
      } else {
        params.product.brand_id = resp.product_brand_id;
        params.product.category = resp.product_types[0].product_type;
        params.product.subcategory = resp.product_types[0].subcategory;
        params.product.category_id = resp.product_types[0].id;
        params.product.category_title = resp.product_types[0].title;
        params.product.category_article = resp.product_types[0].article;
        params.product.category_collective_noun = resp.product_types[0].collective_noun;
        params.product.category_gender = resp.product_types[0].word_gender;
        params.product.gender = resp.product_gender;
        params.product.fit_id = resp.product_fit_id ? resp.product_fit_id : -1;
        params.product.fit = resp.product_fit ? resp.product_fit : params.product.fit;
        params.product.model = resp.product_model ? resp.product_model : params.product.model;
        params.product.model_settings = resp.product_model_settings || [];
        params.shop.language = params.shop.language ? params.shop.language : resp.language;
        params.shop.language = params.shop.language.toLowerCase();
        params.product.supported = true;
        params.easysize.is_loaded = true;

        var parent_group = '';

        if (params.product.category_id === 1) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 2) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 3) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 4) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 5) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 6) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 7) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 8) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 9) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 10) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 11) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 12) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 13) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 14) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 15) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 16) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 17) {
          parent_group = 'ethnic';
        }
        if (params.product.category_id === 18) {
          parent_group = 'ethnic';
        }
        if (params.product.category_id === 19) {
          parent_group = 'ethnic';
        }
        if (params.product.category_id === 20) {
          parent_group = 'ethnic';
        }
        if (params.product.category_id === 21) {
          parent_group = 'footwear';
        }
        if (params.product.category_id === 22) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 23) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 24) {
          parent_group = 'swimwear';
        }
        if (params.product.category_id === 25) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 26) {
          parent_group = 'tops';
        }
        if (params.product.category_id === 27) {
          parent_group = 'bottoms';
        }
        if (params.product.category_id === 28) {
          parent_group = 'sets';
        }

        document.body.classList.add('easysize_group_' + parent_group);
        try {
          if (params.product.subcategory) {
            document.body.classList.add('easysize_subgroup_' + params.product.subcategory.toLowerCase().replace(' ', '').replace('&', ''));
          }
        } catch (e) {}

        emitter.emit('easysize_product_validated');

        // Size insights trigger
        if (params.features.size_insights && resp.product_model_settings) {
          var si_gender = params.product.gender === 'u' ? Object.keys(resp.product_model_settings)[0] : params.product.gender;
          var settings = Object.assign(resp.product_model_settings[si_gender], {
            texts: EasySizeParametersDebug.features.size_insights_texts
          });

          if (Array.isArray(params.features.size_insights)) {
            // Array config
            params.features.size_insights.forEach(function (conf) {
              (0, _sizeInsights.createSizeInsights)(Object.assign(settings, conf));
            });
          } else {
            // Single config
            (0, _sizeInsights.createSizeInsights)(Object.assign(settings, params.features.size_insights));
          }
        }
      }
    }
  });

  // params.elements.add_to_cart_button = Qwery(params.shop.add_to_cart_btn_selector)[0];
  if (window.location.href.indexOf('justfemale') !== -1 || window.location.href.indexOf('secondfemale') !== -1) {
    params.elements.add_to_cart_button = (0, _qwery2.default)('.add-to-cart ' + params.shop.add_to_cart_btn_selector)[0];
  } else {
    params.elements.add_to_cart_button = (0, _qwery2.default)(params.shop.add_to_cart_btn_selector)[0];
  }
  params.elements.button_placeholder = (0, _qwery2.default)(params.shop.easysize_button_placeholder_selector)[0];
  params.elements.size_dropdown = (0, _qwery2.default)(params.shop.size_dropdown_selector)[0];

  try {
    document.removeEventListener('click', handle_cart_click);
  } catch (e) {
    (0, _utilities.debug)(e);
  }
  try {
    window.removeEventListener('easysize-add-to-cart', handle_cart_click);
  } catch (e) {
    (0, _utilities.debug)(e);
  }
  try {
    window.removeEventListener('easysize-size-change', handle_size_change);
  } catch (e) {
    (0, _utilities.debug)(e);
  }
  try {
    window.removeEventListener('easysize-set-language', handle_set_language);
  } catch (e) {
    (0, _utilities.debug)(e);
  }

  document.addEventListener('click', handle_cart_click);
  window.addEventListener('easysize-add-to-cart', handle_cart_click);
  window.addEventListener('easysize-size-change', handle_size_change);
  window.addEventListener('easysize-set-language', handle_set_language);

  (0, _utilities.subscribe)('easysize_size_selected', function (size) {
    (0, _utilities.debug)('Size changed to', size);
    params.shop.selected_size = size;
    params.track(28, size);
  });

  _bean2.default.on(document, 'change', params.shop.size_dropdown_selector, function () {
    try {
      var selected_size = params.elements.size_dropdown.options[params.elements.size_dropdown.selectedIndex].text;
      emitter.emit('easysize_size_selected', selected_size);
    } catch (e) {
      (0, _utilities.debug)(e);
    }
  });
}

function bindEasysizeMessages(params) {
  _bean2.default.on(window, 'message', function (message) {
    (0, _utilities.debug)('[EasySize]: window message received', message);
    if (params.easysize.widget_url.indexOf(message.origin) === 0 || params.easysize.qa_widget_url.indexOf(message.origin) === 0) {
      var data = {};
      try {
        data = JSON.parse(message.data);
      } catch (e) {
        (0, _utilities.debug)('[EasySize]: window message parsing failed', e);
      }

      /*
                SIZE ADVISOR MESSAGES
             */

      // Close easysize size advisor
      if (data.hasOwnProperty('close')) {
        if (params.features.size_advice_qa) {
          new Promise(function(resolve) { resolve(); }).then((function (require) {
            __webpack_require__(0).closeQaAdvisor(params);
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
          __webpack_require__.e/* require.ensure */(4).then((function (require) {
            __webpack_require__(4).closeSizeAdvisor(params);
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        }

        params.shop.custom_css = params.shop.initial_custom_css;
      }

      // Size was not found, remove any returning user text
      if (data.hasOwnProperty('removeReturningUserText')) {
        (0, _utilities.debug)('[EasySize]: removing returning user texts:');
        var es_recommended = (0, _qwery2.default)('.es-recommended')[0];
        var es_selected = (0, _qwery2.default)('.es-selected')[0];
        document.body.classList.remove('es-selected-size');
        document.body.classList.remove('es-recommended-size');
        if (es_recommended) {
          es_recommended.parentNode.removeChild(es_recommended);
        }
        if (es_selected) {
          es_selected.parentNode.removeChild(es_selected);
        }
      }

      // Add user item to wardrobe
      if (data.hasOwnProperty('haveBrand') && data.hasOwnProperty('haveItem') && data.hasOwnProperty('haveSize')) {
        __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function (require) {
          var saveUserItemToWardrobe = __webpack_require__(9).saveUserItemToWardrobe;
          var wardrobeParams = {
            item_gender: params.product.gender.substr(0, 1),
            item_brand: data.haveBrand,
            item_product_type: data.haveItem,
            item_size: data.haveSize,
            source: 'L'
          };

          if (data.hasOwnProperty('haveModel')) {
            wardrobeParams['item_model'] = data.haveModel;
          }

          if (data.hasOwnProperty('haveFit')) {
            wardrobeParams['item_fit'] = data.haveFit;
          }

          saveUserItemToWardrobe(params, wardrobeParams);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      }

      // Dynamically update size dropdown
      if (data.hasOwnProperty('size') || data.hasOwnProperty('sizeAcc')) {
        if (data.hasOwnProperty('recommendedFit')) {
          params.easysize.recommended_fit = data['recommendedFit'];
        }

        if (data.hasOwnProperty('size')) {
          __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function (require) {
            __webpack_require__(4).closeSizeAdvisor(params);
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        }

        var size = data.hasOwnProperty('size') ? data.size : data.sizeAcc;
        (0, _utilities.debug)('[EasySize debug]: Trying to update size dropdown with size', size);
        window.postMessage(JSON.stringify({
          'easysize_tracking': true,
          'action': 7,
          'value': size
        }), '*');
        params.easysize.calculated_size = size;
        params.easysize.original_calculated_size = data.original_calculated_size;
        if (params.product.stock.hasOwnProperty(params.easysize.calculated_size) && params.product.stock[params.easysize.calculated_size] === 0) {
          window.postMessage(JSON.stringify({
            'easysize_tracking': true,
            'action': 21
          }), '*');
          __webpack_require__.e/* require.ensure */(2).then((function (require) {
            var addSizeRecommendedText = __webpack_require__(16)("./" + params.easysize.product).addSizeRecommendedText;
            addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params);
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        }

        if (params.shop.update_size_dropdown(size, params)) {
          emitter.emit('easysize-size-selected');
        }
      }

      if (data.hasOwnProperty('addToCart')) {
        setTimeout(function () {
          /* eslint-disable no-undef */
          params.elements.add_to_cart_button = (0, _qwery2.default)(params.shop.add_to_cart_btn_selector)[0];
          (0, _utilities.debug)('[EasySize]: reassigning add to cart button to', params.elements.add_to_cart_button);

          if (typeof params.shop.add_to_cart === 'function') {
            params.shop.add_to_cart();
          } else if (typeof EasySizeParametersDebug.elements.add_to_cart_button.click === 'function') {
            EasySizeParametersDebug.elements.add_to_cart_button.click();
            /* eslint-enable no-undef */
          } else {
            _bean2.default.fire(params.elements.add_to_cart_button, 'click');
          }
          window.postMessage(JSON.stringify({
            'easysize_tracking': true,
            'action': 19
          }), '*');

          params.shop.custom_css = params.shop.initial_custom_css;
        }, 200);
      }

      if (data.hasOwnProperty('recommended')) {
        var es_recommended_products = _jsCookie2.default.get('es_recommended_products');

        if (es_recommended_products) {
          es_recommended_products = JSON.parse(es_recommended_products);
        } else {
          es_recommended_products = [];
        }

        es_recommended_products.push(data.recommended);
        _jsCookie2.default.set('es_recommended_products', JSON.stringify(es_recommended_products), Infinity, '/');
        if (window.hasOwnProperty('open')) {
          window.open(data.product_url);
        } else {
          window.location.href = data.product_url;
        }
      }

      /*
                SIZE BOT MESSAGES
             */

      if (data.hasOwnProperty('easysize-toggle-size-bot')) {
        // eslint-disable-next-line no-undef
        if (_hasClass('#es-sizebot', 'open')) {
          __webpack_require__.e/* require.ensure */(0).then((function (require) {
            var closeSizeBot = __webpack_require__(5).closeSizeBot;
            closeSizeBot();
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
          __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
            var openSizeBot = __webpack_require__(5).openSizeBot;
            openSizeBot();
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        }
      }

      if (data.hasOwnProperty('easysize-size-bot-close')) {
        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
          __webpack_require__(5).removeSizeBot();
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      }

      if (data.hasOwnProperty('easysize-size-bot-loaded')) {
        // openSizeBot();
        // sizeBotElement.style.display = 'block';
      }
    }
  });

  emitter.on('easysize-size-selected', function () {
    params.track(30);
    __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function (require) {
      var addSizeRecommendedText = __webpack_require__(16)("./" + params.easysize.product).addSizeRecommendedText;
      addSizeRecommendedText('es-recommended', 'returning_user_text', 'es-recommended-size', params);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguage = getLanguage;
exports.debug = debug;
exports.enableDebug = enableDebug;
exports.compareStringIgnoreCase = compareStringIgnoreCase;
exports.subscribe = subscribe;
exports._hasClass = _hasClass;
exports.removeElementsByClassName = removeElementsByClassName;
exports.removeElementsById = removeElementsById;
exports.parseQueryString = parseQueryString;

var _jsCookie = __webpack_require__(6);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _features = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languages = {
  'abkhaz': 'ab',
  'afar': 'aa',
  'afrikaans': 'af',
  'akan': 'ak',
  'albanian': 'sq',
  'amharic': 'am',
  'arabic': 'ar',
  'aragonese': 'an',
  'armenian': 'hy',
  'assamese': 'as',
  'avaric': 'av',
  'avestan': 'ae',
  'aymara': 'ay',
  'azerbaijani': 'az',
  'bambara': 'bm',
  'bashkir': 'ba',
  'basque': 'eu',
  'belarusian': 'be',
  'bengali': 'bn',
  'bihari': 'bh',
  'bislama': 'bi',
  'bosnian': 'bs',
  'breton': 'br',
  'bulgarian': 'bg',
  'burmese': 'my',
  'catalan; valencian': 'ca',
  'chamorro': 'ch',
  'chechen': 'ce',
  'chichewa; chewa; nyanja': 'ny',
  'chinese': 'zh',
  'chuvash': 'cv',
  'cornish': 'kw',
  'corsican': 'co',
  'cree': 'cr',
  'croatian': 'hr',
  'czech': 'cs',
  'danish': 'da',
  'divehi; dhivehi; maldivian;': 'dv',
  'dutch': 'nl',
  'english': 'en',
  'esperanto': 'eo',
  'estonian': 'et',
  'ewe': 'ee',
  'faroese': 'fo',
  'fijian': 'fj',
  'finnish': 'fi',
  'french': 'fr',
  'fula; fulah; pulaar; pular': 'ff',
  'galician': 'gl',
  'georgian': 'ka',
  'german': 'de',
  'greek, modern': 'el',
  'guaraní': 'gn',
  'gujarati': 'gu',
  'haitian; haitian creole': 'ht',
  'hausa': 'ha',
  'hebrew (modern)': 'he',
  'hebrew': 'he',
  'herero': 'hz',
  'hindi': 'hi',
  'hiri motu': 'ho',
  'hungarian': 'hu',
  'interlingua': 'ia',
  'indonesian': 'id',
  'interlingue': 'ie',
  'irish': 'ga',
  'igbo': 'ig',
  'inupiaq': 'ik',
  'ido': 'io',
  'icelandic': 'is',
  'italian': 'it',
  'inuktitut': 'iu',
  'japanese': 'ja',
  'javanese': 'jv',
  'kalaallisut, greenlandic': 'kl',
  'kannada': 'kn',
  'kanuri': 'kr',
  'kashmiri': 'ks',
  'kazakh': 'kk',
  'khmer': 'km',
  'kikuyu, gikuyu': 'ki',
  'kinyarwanda': 'rw',
  'kirghiz, kyrgyz': 'ky',
  'komi': 'kv',
  'kongo': 'kg',
  'korean': 'ko',
  'kurdish': 'ku',
  'kwanyama, kuanyama': 'kj',
  'latin': 'la',
  'luxembourgish, letzeburgesch': 'lb',
  'luganda': 'lg',
  'limburgish, limburgan, limburger': 'li',
  'lingala': 'ln',
  'lao': 'lo',
  'lithuanian': 'lt',
  'luba-katanga': 'lu',
  'latvian': 'lv',
  'manx': 'gv',
  'macedonian': 'mk',
  'malagasy': 'mg',
  'malay': 'ms',
  'malayalam': 'ml',
  'maltese': 'mt',
  'māori': 'mi',
  'marathi (marāṭhī)': 'mr',
  'marshallese': 'mh',
  'mongolian': 'mn',
  'nauru': 'na',
  'navajo, navaho': 'nv',
  // 'norwegian bokmål': 'nb',
  'nb': 'norwegian',
  'north ndebele': 'nd',
  'nepali': 'ne',
  'ndonga': 'ng',
  'norwegian nynorsk': 'nn',
  'norwegian': 'no',
  'nuosu': 'ii',
  'south ndebele': 'nr',
  'occitan': 'oc',
  'ojibwe, ojibwa': 'oj',
  'old church slavonic, church slavic, church slavonic, old bulgarian, old slavonic': 'cu',
  'oromo': 'om',
  'oriya': 'or',
  'ossetian, ossetic': 'os',
  'panjabi, punjabi': 'pa',
  'pāli': 'pi',
  'persian': 'fa',
  'polish': 'pl',
  'pashto, pushto': 'ps',
  'portuguese': 'pt',
  'quechua': 'qu',
  'romansh': 'rm',
  'kirundi': 'rn',
  'romanian': 'ro',
  'russian': 'ru',
  'sanskrit (saṁskṛta)': 'sa',
  'sardinian': 'sc',
  'sindhi': 'sd',
  // 'northern sami': 'se',
  'samoan': 'sm',
  'sango': 'sg',
  'serbian': 'sr',
  'scottish gaelic; gaelic': 'gd',
  'shona': 'sn',
  'sinhala, sinhalese': 'si',
  'slovak': 'sk',
  'slovene': 'sl',
  'somali': 'so',
  'southern sotho': 'st',
  'spanish; castilian': 'es',
  'sundanese': 'su',
  'swahili': 'sw',
  'swati': 'ss',
  'swedish': 'sv',
  'tamil': 'ta',
  'telugu': 'te',
  'tajik': 'tg',
  'thai': 'th',
  'tigrinya': 'ti',
  'tibetan standard, tibetan, central': 'bo',
  'turkmen': 'tk',
  'tagalog': 'tl',
  'tswana': 'tn',
  'tonga (tonga islands)': 'to',
  'turkish': 'tr',
  'tsonga': 'ts',
  'tatar': 'tt',
  'twi': 'tw',
  'tahitian': 'ty',
  'uighur, uyghur': 'ug',
  'ukrainian': 'uk',
  'urdu': 'ur',
  'uzbek': 'uz',
  'venda': 've',
  'vietnamese': 'vi',
  'volapük': 'vo',
  'walloon': 'wa',
  'welsh': 'cy',
  'wolof': 'wo',
  'western frisian': 'fy',
  'xhosa': 'xh',
  'yiddish': 'yi',
  'yoruba': 'yo',
  'zhuang, chuang': 'za'
};

function getLanguage(language) {
  var lang = 'english';
  var lang_code = 'en';
  var found = false;

  if (language.indexOf('-') !== -1) {
    language = language.split('-')[0];
  }

  // Hackaround for language accent support given two letter locales
  // Nees to appear in the languages list with the original two letter language code
  if (languages.hasOwnProperty(language) && language.length == 2) {
    language = languages[language];
  }

  language = language.toLowerCase();

  if (languages.hasOwnProperty(language)) {
    lang = language;
    lang_code = languages[language];
    found = true;
  }

  if (!found) {
    // If not found, it means it's not full language name, but rather a code, so try reverse searching for it
    Object.keys(languages).forEach(function (l) {
      if (languages[l] === language) {
        lang = l;
        lang_code = languages[l];
      }
    });
  }

  return {
    language: lang,
    lang_code: lang_code
  };
}

function debug() {
  // eslint-disable-next-line eqeqeq
  if (_jsCookie2.default.get('easysize_debug_mode') == 'true') {
    var warn = Function.prototype.bind.call(console.warn, console);
    warn.apply(console, arguments);
  }
}

function enableDebug() {
  _jsCookie2.default.set('easysize_debug_mode', true, { expires: 28, secure: true, sameSite: 'strict' });
  return 'EasySize debug enabled';
}

function compareStringIgnoreCase(str1, str2) {
  try {
    return str1.toLowerCase() === str2.toLowerCase();
  } catch (e) {}

  return false;
}

function subscribe(event, callback) {
  var events = event.split(' ');
  for (var i = 0; i < events.length; i++) {
    _features.emitter.on(events[i], callback);
  };
}

function _hasClass(elementSelector, className) {
  var element = (0, _qwery2.default)(elementSelector);
  if (element && element[0]) {
    return element[0].className.indexOf(className) !== -1;
  }

  debug('[EasySize debug]: Element ' + elementSelector + ' does not exist');
  return -1;
}

function removeElementsByClassName(className) {
  var elements = document.getElementsByClassName(className);

  // for (var i = 0; i < elements.length; i++) {
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
}

function removeElementsById(className) {
  var element = document.getElementById(className);
  if (element) {
    element.parentNode.removeChild(element);
  }
}

function parseQueryString(query) {
  if (!query) {
    return {};
  }

  var vars = query.split('&');
  var queryString = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof queryString[key] === 'undefined') {
      queryString[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof queryString[key] === 'string') {
      var arr = [queryString[key], decodeURIComponent(value)];
      queryString[key] = arr;
      // If third or later entry with this name
    } else {
      queryString[key].push(decodeURIComponent(value));
    }
  }
  return queryString;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * @preserve Qwery - A selector engine
  * https://github.com/ded/qwery
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else context[name] = definition()
})('qwery', this, function () {

  var classOnly = /^\.([\w\-]+)$/
    , doc = document
    , win = window
    , html = doc.documentElement
    , nodeType = 'nodeType'
  var isAncestor = 'compareDocumentPosition' in html ?
    function (element, container) {
      return (container.compareDocumentPosition(element) & 16) == 16
    } :
    function (element, container) {
      container = container == doc || container == window ? html : container
      return container !== element && container.contains(element)
    }

  function toArray(ar) {
    return [].slice.call(ar, 0)
  }

  function isNode(el) {
    var t
    return el && typeof el === 'object' && (t = el.nodeType) && (t == 1 || t == 9)
  }

  function arrayLike(o) {
    return (typeof o === 'object' && isFinite(o.length))
  }

  function flatten(ar) {
    for (var r = [], i = 0, l = ar.length; i < l; ++i) arrayLike(ar[i]) ? (r = r.concat(ar[i])) : (r[r.length] = ar[i])
    return r
  }

  function uniq(ar) {
    var a = [], i, j
    label:
    for (i = 0; i < ar.length; i++) {
      for (j = 0; j < a.length; j++) {
        if (a[j] == ar[i]) {
          continue label
        }
      }
      a[a.length] = ar[i]
    }
    return a
  }


  function normalizeRoot(root) {
    if (!root) return doc
    if (typeof root == 'string') return qwery(root)[0]
    if (!root[nodeType] && arrayLike(root)) return root[0]
    return root
  }

  /**
   * @param {string|Array.<Element>|Element|Node} selector
   * @param {string|Array.<Element>|Element|Node=} opt_root
   * @return {Array.<Element>}
   */
  function qwery(selector, opt_root) {
    var m, root = normalizeRoot(opt_root)
    if (!root || !selector) return []
    if (selector === win || isNode(selector)) {
      return !opt_root || (selector !== win && isNode(root) && isAncestor(selector, root)) ? [selector] : []
    }
    if (selector && arrayLike(selector)) return flatten(selector)


    if (doc.getElementsByClassName && selector == 'string' && (m = selector.match(classOnly))) {
      return toArray((root).getElementsByClassName(m[1]))
    }
    // using duck typing for 'a' window or 'a' document (not 'the' window || document)
    if (selector && (selector.document || (selector.nodeType && selector.nodeType == 9))) {
      return !opt_root ? [selector] : []
    }
    return toArray((root).querySelectorAll(selector))
  }

  qwery.uniq = uniq

  return qwery
}, this);


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Bean - copyright (c) Jacob Thornton 2011-2012
  * https://github.com/fat/bean
  * MIT license
  */
(function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else context[name] = definition()
})('bean', this, function (name, context) {
  name    = name    || 'bean'
  context = context || this

  var win            = window
    , old            = context[name]
    , namespaceRegex = /[^\.]*(?=\..*)\.|.*/
    , nameRegex      = /\..*/
    , addEvent       = 'addEventListener'
    , removeEvent    = 'removeEventListener'
    , doc            = document || {}
    , root           = doc.documentElement || {}
    , W3C_MODEL      = root[addEvent]
    , eventSupport   = W3C_MODEL ? addEvent : 'attachEvent'
    , ONE            = {} // singleton for quick matching making add() do one()

    , slice          = Array.prototype.slice
    , str2arr        = function (s, d) { return s.split(d || ' ') }
    , isString       = function (o) { return typeof o == 'string' }
    , isFunction     = function (o) { return typeof o == 'function' }

      // events that we consider to be 'native', anything not in this list will
      // be treated as a custom event
    , standardNativeEvents =
        'click dblclick mouseup mousedown contextmenu '                  + // mouse buttons
        'mousewheel mousemultiwheel DOMMouseScroll '                     + // mouse wheel
        'mouseover mouseout mousemove selectstart selectend '            + // mouse movement
        'keydown keypress keyup '                                        + // keyboard
        'orientationchange '                                             + // mobile
        'focus blur change reset select submit '                         + // form elements
        'load unload beforeunload resize move DOMContentLoaded '         + // window
        'readystatechange message '                                      + // window
        'error abort scroll '                                              // misc
      // element.fireEvent('onXYZ'... is not forgiving if we try to fire an event
      // that doesn't actually exist, so make sure we only do these on newer browsers
    , w3cNativeEvents =
        'show '                                                          + // mouse buttons
        'input invalid '                                                 + // form elements
        'touchstart touchmove touchend touchcancel '                     + // touch
        'gesturestart gesturechange gestureend '                         + // gesture
        'textinput '                                                     + // TextEvent
        'readystatechange pageshow pagehide popstate '                   + // window
        'hashchange offline online '                                     + // window
        'afterprint beforeprint '                                        + // printing
        'dragstart dragenter dragover dragleave drag drop dragend '      + // dnd
        'loadstart progress suspend emptied stalled loadmetadata '       + // media
        'loadeddata canplay canplaythrough playing waiting seeking '     + // media
        'seeked ended durationchange timeupdate play pause ratechange '  + // media
        'volumechange cuechange '                                        + // media
        'checking noupdate downloading cached updateready obsolete '       // appcache

      // convert to a hash for quick lookups
    , nativeEvents = (function (hash, events, i) {
        for (i = 0; i < events.length; i++) events[i] && (hash[events[i]] = 1)
        return hash
      }({}, str2arr(standardNativeEvents + (W3C_MODEL ? w3cNativeEvents : ''))))

      // custom events are events that we *fake*, they are not provided natively but
      // we can use native events to generate them
    , customEvents = (function () {
        var isAncestor = 'compareDocumentPosition' in root
              ? function (element, container) {
                  return container.compareDocumentPosition && (container.compareDocumentPosition(element) & 16) === 16
                }
              : 'contains' in root
                ? function (element, container) {
                    container = container.nodeType === 9 || container === window ? root : container
                    return container !== element && container.contains(element)
                  }
                : function (element, container) {
                    while (element = element.parentNode) if (element === container) return 1
                    return 0
                  }
          , check = function (event) {
              var related = event.relatedTarget
              return !related
                ? related == null
                : (related !== this && related.prefix !== 'xul' && !/document/.test(this.toString())
                    && !isAncestor(related, this))
            }

        return {
            mouseenter: { base: 'mouseover', condition: check }
          , mouseleave: { base: 'mouseout', condition: check }
          , mousewheel: { base: /Firefox/.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel' }
        }
      }())

      // we provide a consistent Event object across browsers by taking the actual DOM
      // event object and generating a new one from its properties.
    , Event = (function () {
            // a whitelist of properties (for different event types) tells us what to check for and copy
        var commonProps  = str2arr('altKey attrChange attrName bubbles cancelable ctrlKey currentTarget ' +
              'detail eventPhase getModifierState isTrusted metaKey relatedNode relatedTarget shiftKey '  +
              'srcElement target timeStamp type view which propertyName')
          , mouseProps   = commonProps.concat(str2arr('button buttons clientX clientY dataTransfer '      +
              'fromElement offsetX offsetY pageX pageY screenX screenY toElement'))
          , mouseWheelProps = mouseProps.concat(str2arr('wheelDelta wheelDeltaX wheelDeltaY wheelDeltaZ ' +
              'axis')) // 'axis' is FF specific
          , keyProps     = commonProps.concat(str2arr('char charCode key keyCode keyIdentifier '          +
              'keyLocation location'))
          , textProps    = commonProps.concat(str2arr('data'))
          , touchProps   = commonProps.concat(str2arr('touches targetTouches changedTouches scale rotation'))
          , messageProps = commonProps.concat(str2arr('data origin source'))
          , stateProps   = commonProps.concat(str2arr('state'))
          , overOutRegex = /over|out/
            // some event types need special handling and some need special properties, do that all here
          , typeFixers   = [
                { // key events
                    reg: /key/i
                  , fix: function (event, newEvent) {
                      newEvent.keyCode = event.keyCode || event.which
                      return keyProps
                    }
                }
              , { // mouse events
                    reg: /click|mouse(?!(.*wheel|scroll))|menu|drag|drop/i
                  , fix: function (event, newEvent, type) {
                      newEvent.rightClick = event.which === 3 || event.button === 2
                      newEvent.pos = { x: 0, y: 0 }
                      if (event.pageX || event.pageY) {
                        newEvent.clientX = event.pageX
                        newEvent.clientY = event.pageY
                      } else if (event.clientX || event.clientY) {
                        newEvent.clientX = event.clientX + doc.body.scrollLeft + root.scrollLeft
                        newEvent.clientY = event.clientY + doc.body.scrollTop + root.scrollTop
                      }
                      if (overOutRegex.test(type)) {
                        newEvent.relatedTarget = event.relatedTarget
                          || event[(type == 'mouseover' ? 'from' : 'to') + 'Element']
                      }
                      return mouseProps
                    }
                }
              , { // mouse wheel events
                    reg: /mouse.*(wheel|scroll)/i
                  , fix: function () { return mouseWheelProps }
                }
              , { // TextEvent
                    reg: /^text/i
                  , fix: function () { return textProps }
                }
              , { // touch and gesture events
                    reg: /^touch|^gesture/i
                  , fix: function () { return touchProps }
                }
              , { // message events
                    reg: /^message$/i
                  , fix: function () { return messageProps }
                }
              , { // popstate events
                    reg: /^popstate$/i
                  , fix: function () { return stateProps }
                }
              , { // everything else
                    reg: /.*/
                  , fix: function () { return commonProps }
                }
            ]
          , typeFixerMap = {} // used to map event types to fixer functions (above), a basic cache mechanism

          , Event = function (event, element, isNative) {
              if (!arguments.length) return
              event = event || ((element.ownerDocument || element.document || element).parentWindow || win).event
              this.originalEvent = event
              this.isNative       = isNative
              this.isBean         = true

              if (!event) return

              var type   = event.type
                , target = event.target || event.srcElement
                , i, l, p, props, fixer

              this.target = target && target.nodeType === 3 ? target.parentNode : target

              if (isNative) { // we only need basic augmentation on custom events, the rest expensive & pointless
                fixer = typeFixerMap[type]
                if (!fixer) { // haven't encountered this event type before, map a fixer function for it
                  for (i = 0, l = typeFixers.length; i < l; i++) {
                    if (typeFixers[i].reg.test(type)) { // guaranteed to match at least one, last is .*
                      typeFixerMap[type] = fixer = typeFixers[i].fix
                      break
                    }
                  }
                }

                props = fixer(event, this, type)
                for (i = props.length; i--;) {
                  if (!((p = props[i]) in this) && p in event) this[p] = event[p]
                }
              }
            }

        // preventDefault() and stopPropagation() are a consistent interface to those functions
        // on the DOM, stop() is an alias for both of them together
        Event.prototype.preventDefault = function () {
          if (this.originalEvent.preventDefault) this.originalEvent.preventDefault()
          else this.originalEvent.returnValue = false
        }
        Event.prototype.stopPropagation = function () {
          if (this.originalEvent.stopPropagation) this.originalEvent.stopPropagation()
          else this.originalEvent.cancelBubble = true
        }
        Event.prototype.stop = function () {
          this.preventDefault()
          this.stopPropagation()
          this.stopped = true
        }
        // stopImmediatePropagation() has to be handled internally because we manage the event list for
        // each element
        // note that originalElement may be a Bean#Event object in some situations
        Event.prototype.stopImmediatePropagation = function () {
          if (this.originalEvent.stopImmediatePropagation) this.originalEvent.stopImmediatePropagation()
          this.isImmediatePropagationStopped = function () { return true }
        }
        Event.prototype.isImmediatePropagationStopped = function () {
          return this.originalEvent.isImmediatePropagationStopped && this.originalEvent.isImmediatePropagationStopped()
        }
        Event.prototype.clone = function (currentTarget) {
          //TODO: this is ripe for optimisation, new events are *expensive*
          // improving this will speed up delegated events
          var ne = new Event(this, this.element, this.isNative)
          ne.currentTarget = currentTarget
          return ne
        }

        return Event
      }())

      // if we're in old IE we can't do onpropertychange on doc or win so we use doc.documentElement for both
    , targetElement = function (element, isNative) {
        return !W3C_MODEL && !isNative && (element === doc || element === win) ? root : element
      }

      /**
        * Bean maintains an internal registry for event listeners. We don't touch elements, objects
        * or functions to identify them, instead we store everything in the registry.
        * Each event listener has a RegEntry object, we have one 'registry' for the whole instance.
        */
    , RegEntry = (function () {
        // each handler is wrapped so we can handle delegation and custom events
        var wrappedHandler = function (element, fn, condition, args) {
            var call = function (event, eargs) {
                  return fn.apply(element, args ? slice.call(eargs, event ? 0 : 1).concat(args) : eargs)
                }
              , findTarget = function (event, eventElement) {
                  return fn.__beanDel ? fn.__beanDel.ft(event.target, element) : eventElement
                }
              , handler = condition
                  ? function (event) {
                      var target = findTarget(event, this) // deleated event
                      if (condition.apply(target, arguments)) {
                        if (event) event.currentTarget = target
                        return call(event, arguments)
                      }
                    }
                  : function (event) {
                      if (fn.__beanDel) event = event.clone(findTarget(event)) // delegated event, fix the fix
                      return call(event, arguments)
                    }
            handler.__beanDel = fn.__beanDel
            return handler
          }

        , RegEntry = function (element, type, handler, original, namespaces, args, root) {
            var customType     = customEvents[type]
              , isNative

            if (type == 'unload') {
              // self clean-up
              handler = once(removeListener, element, type, handler, original)
            }

            if (customType) {
              if (customType.condition) {
                handler = wrappedHandler(element, handler, customType.condition, args)
              }
              type = customType.base || type
            }

            this.isNative      = isNative = nativeEvents[type] && !!element[eventSupport]
            this.customType    = !W3C_MODEL && !isNative && type
            this.element       = element
            this.type          = type
            this.original      = original
            this.namespaces    = namespaces
            this.eventType     = W3C_MODEL || isNative ? type : 'propertychange'
            this.target        = targetElement(element, isNative)
            this[eventSupport] = !!this.target[eventSupport]
            this.root          = root
            this.handler       = wrappedHandler(element, handler, null, args)
          }

        // given a list of namespaces, is our entry in any of them?
        RegEntry.prototype.inNamespaces = function (checkNamespaces) {
          var i, j, c = 0
          if (!checkNamespaces) return true
          if (!this.namespaces) return false
          for (i = checkNamespaces.length; i--;) {
            for (j = this.namespaces.length; j--;) {
              if (checkNamespaces[i] == this.namespaces[j]) c++
            }
          }
          return checkNamespaces.length === c
        }

        // match by element, original fn (opt), handler fn (opt)
        RegEntry.prototype.matches = function (checkElement, checkOriginal, checkHandler) {
          return this.element === checkElement &&
            (!checkOriginal || this.original === checkOriginal) &&
            (!checkHandler || this.handler === checkHandler)
        }

        return RegEntry
      }())

    , registry = (function () {
        // our map stores arrays by event type, just because it's better than storing
        // everything in a single array.
        // uses '$' as a prefix for the keys for safety and 'r' as a special prefix for
        // rootListeners so we can look them up fast
        var map = {}

          // generic functional search of our registry for matching listeners,
          // `fn` returns false to break out of the loop
          , forAll = function (element, type, original, handler, root, fn) {
              var pfx = root ? 'r' : '$'
              if (!type || type == '*') {
                // search the whole registry
                for (var t in map) {
                  if (t.charAt(0) == pfx) {
                    forAll(element, t.substr(1), original, handler, root, fn)
                  }
                }
              } else {
                var i = 0, l, list = map[pfx + type], all = element == '*'
                if (!list) return
                for (l = list.length; i < l; i++) {
                  if ((all || list[i].matches(element, original, handler)) && !fn(list[i], list, i, type)) return
                }
              }
            }

          , has = function (element, type, original, root) {
              // we're not using forAll here simply because it's a bit slower and this
              // needs to be fast
              var i, list = map[(root ? 'r' : '$') + type]
              if (list) {
                for (i = list.length; i--;) {
                  if (!list[i].root && list[i].matches(element, original, null)) return true
                }
              }
              return false
            }

          , get = function (element, type, original, root) {
              var entries = []
              forAll(element, type, original, null, root, function (entry) {
                return entries.push(entry)
              })
              return entries
            }

          , put = function (entry) {
              var has = !entry.root && !this.has(entry.element, entry.type, null, false)
                , key = (entry.root ? 'r' : '$') + entry.type
              ;(map[key] || (map[key] = [])).push(entry)
              return has
            }

          , del = function (entry) {
              forAll(entry.element, entry.type, null, entry.handler, entry.root, function (entry, list, i) {
                list.splice(i, 1)
                entry.removed = true
                if (list.length === 0) delete map[(entry.root ? 'r' : '$') + entry.type]
                return false
              })
            }

            // dump all entries, used for onunload
          , entries = function () {
              var t, entries = []
              for (t in map) {
                if (t.charAt(0) == '$') entries = entries.concat(map[t])
              }
              return entries
            }

        return { has: has, get: get, put: put, del: del, entries: entries }
      }())

      // we need a selector engine for delegated events, use querySelectorAll if it exists
      // but for older browsers we need Qwery, Sizzle or similar
    , selectorEngine
    , setSelectorEngine = function (e) {
        if (!arguments.length) {
          selectorEngine = doc.querySelectorAll
            ? function (s, r) {
                return r.querySelectorAll(s)
              }
            : function () {
                throw new Error('Bean: No selector engine installed') // eeek
              }
        } else {
          selectorEngine = e
        }
      }

      // we attach this listener to each DOM event that we need to listen to, only once
      // per event type per DOM element
    , rootListener = function (event, type) {
        if (!W3C_MODEL && type && event && event.propertyName != '_on' + type) return

        var listeners = registry.get(this, type || event.type, null, false)
          , l = listeners.length
          , i = 0

        event = new Event(event, this, true)
        if (type) event.type = type

        // iterate through all handlers registered for this type, calling them unless they have
        // been removed by a previous handler or stopImmediatePropagation() has been called
        for (; i < l && !event.isImmediatePropagationStopped(); i++) {
          if (!listeners[i].removed) listeners[i].handler.call(this, event)
        }
      }

      // add and remove listeners to DOM elements
    , listener = W3C_MODEL
        ? function (element, type, add) {
            // new browsers
            element[add ? addEvent : removeEvent](type, rootListener, false)
          }
        : function (element, type, add, custom) {
            // IE8 and below, use attachEvent/detachEvent and we have to piggy-back propertychange events
            // to simulate event bubbling etc.
            var entry
            if (add) {
              registry.put(entry = new RegEntry(
                  element
                , custom || type
                , function (event) { // handler
                    rootListener.call(element, event, custom)
                  }
                , rootListener
                , null
                , null
                , true // is root
              ))
              if (custom && element['_on' + custom] == null) element['_on' + custom] = 0
              entry.target.attachEvent('on' + entry.eventType, entry.handler)
            } else {
              entry = registry.get(element, custom || type, rootListener, true)[0]
              if (entry) {
                entry.target.detachEvent('on' + entry.eventType, entry.handler)
                registry.del(entry)
              }
            }
          }

    , once = function (rm, element, type, fn, originalFn) {
        // wrap the handler in a handler that does a remove as well
        return function () {
          fn.apply(this, arguments)
          rm(element, type, originalFn)
        }
      }

    , removeListener = function (element, orgType, handler, namespaces) {
        var type     = orgType && orgType.replace(nameRegex, '')
          , handlers = registry.get(element, type, null, false)
          , removed  = {}
          , i, l

        for (i = 0, l = handlers.length; i < l; i++) {
          if ((!handler || handlers[i].original === handler) && handlers[i].inNamespaces(namespaces)) {
            // TODO: this is problematic, we have a registry.get() and registry.del() that
            // both do registry searches so we waste cycles doing this. Needs to be rolled into
            // a single registry.forAll(fn) that removes while finding, but the catch is that
            // we'll be splicing the arrays that we're iterating over. Needs extra tests to
            // make sure we don't screw it up. @rvagg
            registry.del(handlers[i])
            if (!removed[handlers[i].eventType] && handlers[i][eventSupport])
              removed[handlers[i].eventType] = { t: handlers[i].eventType, c: handlers[i].type }
          }
        }
        // check each type/element for removed listeners and remove the rootListener where it's no longer needed
        for (i in removed) {
          if (!registry.has(element, removed[i].t, null, false)) {
            // last listener of this type, remove the rootListener
            listener(element, removed[i].t, false, removed[i].c)
          }
        }
      }

      // set up a delegate helper using the given selector, wrap the handler function
    , delegate = function (selector, fn) {
        //TODO: findTarget (therefore $) is called twice, once for match and once for
        // setting e.currentTarget, fix this so it's only needed once
        var findTarget = function (target, root) {
              var i, array = isString(selector) ? selectorEngine(selector, root) : selector
              for (; target && target !== root; target = target.parentNode) {
                for (i = array.length; i--;) {
                  if (array[i] === target) return target
                }
              }
            }
          , handler = function (e) {
              var match = findTarget(e.target, this)
              if (match) fn.apply(match, arguments)
            }

        // __beanDel isn't pleasant but it's a private function, not exposed outside of Bean
        handler.__beanDel = {
            ft       : findTarget // attach it here for customEvents to use too
          , selector : selector
        }
        return handler
      }

    , fireListener = W3C_MODEL ? function (isNative, type, element) {
        // modern browsers, do a proper dispatchEvent()
        var evt = doc.createEvent(isNative ? 'HTMLEvents' : 'UIEvents')
        evt[isNative ? 'initEvent' : 'initUIEvent'](type, true, true, win, 1)
        element.dispatchEvent(evt)
      } : function (isNative, type, element) {
        // old browser use onpropertychange, just increment a custom property to trigger the event
        element = targetElement(element, isNative)
        isNative ? element.fireEvent('on' + type, doc.createEventObject()) : element['_on' + type]++
      }

      /**
        * Public API: off(), on(), add(), (remove()), one(), fire(), clone()
        */

      /**
        * off(element[, eventType(s)[, handler ]])
        */
    , off = function (element, typeSpec, fn) {
        var isTypeStr = isString(typeSpec)
          , k, type, namespaces, i

        if (isTypeStr && typeSpec.indexOf(' ') > 0) {
          // off(el, 't1 t2 t3', fn) or off(el, 't1 t2 t3')
          typeSpec = str2arr(typeSpec)
          for (i = typeSpec.length; i--;)
            off(element, typeSpec[i], fn)
          return element
        }

        type = isTypeStr && typeSpec.replace(nameRegex, '')
        if (type && customEvents[type]) type = customEvents[type].base

        if (!typeSpec || isTypeStr) {
          // off(el) or off(el, t1.ns) or off(el, .ns) or off(el, .ns1.ns2.ns3)
          if (namespaces = isTypeStr && typeSpec.replace(namespaceRegex, '')) namespaces = str2arr(namespaces, '.')
          removeListener(element, type, fn, namespaces)
        } else if (isFunction(typeSpec)) {
          // off(el, fn)
          removeListener(element, null, typeSpec)
        } else {
          // off(el, { t1: fn1, t2, fn2 })
          for (k in typeSpec) {
            if (typeSpec.hasOwnProperty(k)) off(element, k, typeSpec[k])
          }
        }

        return element
      }

      /**
        * on(element, eventType(s)[, selector], handler[, args ])
        */
    , on = function(element, events, selector, fn) {
        var originalFn, type, types, i, args, entry, first

        //TODO: the undefined check means you can't pass an 'args' argument, fix this perhaps?
        if (selector === undefined && typeof events == 'object') {
          //TODO: this can't handle delegated events
          for (type in events) {
            if (events.hasOwnProperty(type)) {
              on.call(this, element, type, events[type])
            }
          }
          return
        }

        if (!isFunction(selector)) {
          // delegated event
          originalFn = fn
          args       = slice.call(arguments, 4)
          fn         = delegate(selector, originalFn, selectorEngine)
        } else {
          args       = slice.call(arguments, 3)
          fn         = originalFn = selector
        }

        types = str2arr(events)

        // special case for one(), wrap in a self-removing handler
        if (this === ONE) {
          fn = once(off, element, events, fn, originalFn)
        }

        for (i = types.length; i--;) {
          // add new handler to the registry and check if it's the first for this element/type
          first = registry.put(entry = new RegEntry(
              element
            , types[i].replace(nameRegex, '') // event type
            , fn
            , originalFn
            , str2arr(types[i].replace(namespaceRegex, ''), '.') // namespaces
            , args
            , false // not root
          ))
          if (entry[eventSupport] && first) {
            // first event of this type on this element, add root listener
            listener(element, entry.eventType, true, entry.customType)
          }
        }

        return element
      }

      /**
        * add(element[, selector], eventType(s), handler[, args ])
        *
        * Deprecated: kept (for now) for backward-compatibility
        */
    , add = function (element, events, fn, delfn) {
        return on.apply(
            null
          , !isString(fn)
              ? slice.call(arguments)
              : [ element, fn, events, delfn ].concat(arguments.length > 3 ? slice.call(arguments, 5) : [])
        )
      }

      /**
        * one(element, eventType(s)[, selector], handler[, args ])
        */
    , one = function () {
        return on.apply(ONE, arguments)
      }

      /**
        * fire(element, eventType(s)[, args ])
        *
        * The optional 'args' argument must be an array, if no 'args' argument is provided
        * then we can use the browser's DOM event system, otherwise we trigger handlers manually
        */
    , fire = function (element, type, args) {
        var types = str2arr(type)
          , i, j, l, names, handlers

        for (i = types.length; i--;) {
          type = types[i].replace(nameRegex, '')
          if (names = types[i].replace(namespaceRegex, '')) names = str2arr(names, '.')
          if (!names && !args && element[eventSupport]) {
            fireListener(nativeEvents[type], type, element)
          } else {
            // non-native event, either because of a namespace, arguments or a non DOM element
            // iterate over all listeners and manually 'fire'
            handlers = registry.get(element, type, null, false)
            args = [false].concat(args)
            for (j = 0, l = handlers.length; j < l; j++) {
              if (handlers[j].inNamespaces(names)) {
                handlers[j].handler.apply(element, args)
              }
            }
          }
        }
        return element
      }

      /**
        * clone(dstElement, srcElement[, eventType ])
        *
        * TODO: perhaps for consistency we should allow the same flexibility in type specifiers?
        */
    , clone = function (element, from, type) {
        var handlers = registry.get(from, type, null, false)
          , l = handlers.length
          , i = 0
          , args, beanDel

        for (; i < l; i++) {
          if (handlers[i].original) {
            args = [ element, handlers[i].type ]
            if (beanDel = handlers[i].handler.__beanDel) args.push(beanDel.selector)
            args.push(handlers[i].original)
            on.apply(null, args)
          }
        }
        return element
      }

    , bean = {
          'on'                : on
        , 'add'               : add
        , 'one'               : one
        , 'off'               : off
        , 'remove'            : off
        , 'clone'             : clone
        , 'fire'              : fire
        , 'Event'             : Event
        , 'setSelectorEngine' : setSelectorEngine
        , 'noConflict'        : function () {
            context[name] = old
            return this
          }
      }

  // for IE, clean up on unload to avoid leaks
  if (win.attachEvent) {
    var cleanup = function () {
      var i, entries = registry.entries()
      for (i in entries) {
        if (entries[i].type && entries[i].type !== 'unload') off(entries[i].element, entries[i].type)
      }
      win.detachEvent('onunload', cleanup)
      win.CollectGarbage && win.CollectGarbage()
    }
    win.attachEvent('onunload', cleanup)
  }

  // initialize selector engine to internal default (qSA or throw Error)
  setSelectorEngine()

  return bean
});


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Reqwest! A general purpose XHR connection manager
  * license MIT (c) Dustin Diaz 2015
  * https://github.com/ded/reqwest
  */

!function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else context[name] = definition()
}('reqwest', this, function () {

  var context = this

  if ('window' in context) {
    var doc = document
      , byTag = 'getElementsByTagName'
      , head = doc[byTag]('head')[0]
  } else {
    var XHR2
    try {
      XHR2 = __webpack_require__(26)
    } catch (ex) {
      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
    }
  }


  var httpsRe = /^http/
    , protocolRe = /(^\w+):\/\//
    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    , readyState = 'readyState'
    , contentType = 'Content-Type'
    , requestedWith = 'X-Requested-With'
    , uniqid = 0
    , callbackPrefix = 'reqwest_' + (+new Date())
    , lastValue // data stored by the most recent JSONP callback
    , xmlHttpRequest = 'XMLHttpRequest'
    , xDomainRequest = 'XDomainRequest'
    , noop = function () {}

    , isArray = typeof Array.isArray == 'function'
        ? Array.isArray
        : function (a) {
            return a instanceof Array
          }

    , defaultHeaders = {
          'contentType': 'application/x-www-form-urlencoded'
        , 'requestedWith': xmlHttpRequest
        , 'accept': {
              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
            , 'xml':  'application/xml, text/xml'
            , 'html': 'text/html'
            , 'text': 'text/plain'
            , 'json': 'application/json, text/javascript'
            , 'js':   'application/javascript, text/javascript'
          }
      }

    , xhr = function(o) {
        // is it x-domain
        if (o['crossOrigin'] === true) {
          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
          if (xhr && 'withCredentials' in xhr) {
            return xhr
          } else if (context[xDomainRequest]) {
            return new XDomainRequest()
          } else {
            throw new Error('Browser does not support cross-origin requests')
          }
        } else if (context[xmlHttpRequest]) {
          return new XMLHttpRequest()
        } else if (XHR2) {
          return new XHR2()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      }
    , globalSetupOptions = {
        dataFilter: function (data) {
          return data
        }
      }

  function succeed(r) {
    var protocol = protocolRe.exec(r.url)
    protocol = (protocol && protocol[1]) || context.location.protocol
    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
  }

  function handleReadyState(r, success, error) {
    return function () {
      // use _aborted to mitigate against IE err c00c023f
      // (can't read props on aborted request objects)
      if (r._aborted) return error(r.request)
      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
      if (r.request && r.request[readyState] == 4) {
        r.request.onreadystatechange = noop
        if (succeed(r)) success(r.request)
        else
          error(r.request)
      }
    }
  }

  function setHeaders(http, o) {
    var headers = o['headers'] || {}
      , h

    headers['Accept'] = headers['Accept']
      || defaultHeaders['accept'][o['type']]
      || defaultHeaders['accept']['*']

    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
    // breaks cross-origin requests with legacy browsers
    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
    for (h in headers)
      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
  }

  function setCredentials(http, o) {
    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
      http.withCredentials = !!o['withCredentials']
    }
  }

  function generalCallback(data) {
    lastValue = data
  }

  function urlappend (url, s) {
    return url + (/\?/.test(url) ? '&' : '?') + s
  }

  function handleJsonp(o, fn, err, url) {
    var reqId = uniqid++
      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
      , match = url.match(cbreg)
      , script = doc.createElement('script')
      , loaded = 0
      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1

    if (match) {
      if (match[3] === '?') {
        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
      } else {
        cbval = match[3] // provided callback func name
      }
    } else {
      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
    }

    context[cbval] = generalCallback

    script.type = 'text/javascript'
    script.src = url
    script.async = true
    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
      // need this for IE due to out-of-order onreadystatechange(), binding script
      // execution to an event listener gives us control over when the script
      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
      script.htmlFor = script.id = '_reqwest_' + reqId
    }

    script.onload = script.onreadystatechange = function () {
      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
        return false
      }
      script.onload = script.onreadystatechange = null
      script.onclick && script.onclick()
      // Call the user callback with the last value stored and clean up values and scripts.
      fn(lastValue)
      lastValue = undefined
      head.removeChild(script)
      loaded = 1
    }

    // Add the script to the DOM head
    head.appendChild(script)

    // Enable JSONP timeout
    return {
      abort: function () {
        script.onload = script.onreadystatechange = null
        err({}, 'Request is aborted: timeout', {})
        lastValue = undefined
        head.removeChild(script)
        loaded = 1
      }
    }
  }

  function getRequest(fn, err) {
    var o = this.o
      , method = (o['method'] || 'GET').toUpperCase()
      , url = typeof o === 'string' ? o : o['url']
      // convert non-string objects to query-string form unless o['processData'] is false
      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
        ? reqwest.toQueryString(o['data'])
        : (o['data'] || null)
      , http
      , sendWait = false

    // if we're working on a GET request and we have data then we should append
    // query string to end of URL and not post data
    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
      url = urlappend(url, data)
      data = null
    }

    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)

    // get the xhr from the factory if passed
    // if the factory returns null, fall-back to ours
    http = (o.xhr && o.xhr(o)) || xhr(o)

    http.open(method, url, o['async'] === false ? false : true)
    setHeaders(http, o)
    setCredentials(http, o)
    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
        http.onload = fn
        http.onerror = err
        // NOTE: see
        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
        http.onprogress = function() {}
        sendWait = true
    } else {
      http.onreadystatechange = handleReadyState(this, fn, err)
    }
    o['before'] && o['before'](http)
    if (sendWait) {
      setTimeout(function () {
        http.send(data)
      }, 200)
    } else {
      http.send(data)
    }
    return http
  }

  function Reqwest(o, fn) {
    this.o = o
    this.fn = fn

    init.apply(this, arguments)
  }

  function setType(header) {
    // json, javascript, text/plain, text/html, xml
    if (header === null) return undefined; //In case of no content-type.
    if (header.match('json')) return 'json'
    if (header.match('javascript')) return 'js'
    if (header.match('text')) return 'html'
    if (header.match('xml')) return 'xml'
  }

  function init(o, fn) {

    this.url = typeof o == 'string' ? o : o['url']
    this.timeout = null

    // whether request has been fulfilled for purpose
    // of tracking the Promises
    this._fulfilled = false
    // success handlers
    this._successHandler = function(){}
    this._fulfillmentHandlers = []
    // error handlers
    this._errorHandlers = []
    // complete (both success and fail) handlers
    this._completeHandlers = []
    this._erred = false
    this._responseArgs = {}

    var self = this

    fn = fn || function () {}

    if (o['timeout']) {
      this.timeout = setTimeout(function () {
        timedOut()
      }, o['timeout'])
    }

    if (o['success']) {
      this._successHandler = function () {
        o['success'].apply(o, arguments)
      }
    }

    if (o['error']) {
      this._errorHandlers.push(function () {
        o['error'].apply(o, arguments)
      })
    }

    if (o['complete']) {
      this._completeHandlers.push(function () {
        o['complete'].apply(o, arguments)
      })
    }

    function complete (resp) {
      o['timeout'] && clearTimeout(self.timeout)
      self.timeout = null
      while (self._completeHandlers.length > 0) {
        self._completeHandlers.shift()(resp)
      }
    }

    function success (resp) {
      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
      resp = (type !== 'jsonp') ? self.request : resp
      // use global data filter on response text
      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
        , r = filteredResponse
      try {
        resp.responseText = r
      } catch (e) {
        // can't assign this in IE<=8, just ignore
      }
      if (r) {
        switch (type) {
        case 'json':
          try {
            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
          } catch (err) {
            return error(resp, 'Could not parse JSON in response', err)
          }
          break
        case 'js':
          resp = eval(r)
          break
        case 'html':
          resp = r
          break
        case 'xml':
          resp = resp.responseXML
              && resp.responseXML.parseError // IE trololo
              && resp.responseXML.parseError.errorCode
              && resp.responseXML.parseError.reason
            ? null
            : resp.responseXML
          break
        }
      }

      self._responseArgs.resp = resp
      self._fulfilled = true
      fn(resp)
      self._successHandler(resp)
      while (self._fulfillmentHandlers.length > 0) {
        resp = self._fulfillmentHandlers.shift()(resp)
      }

      complete(resp)
    }

    function timedOut() {
      self._timedOut = true
      self.request.abort()
    }

    function error(resp, msg, t) {
      resp = self.request
      self._responseArgs.resp = resp
      self._responseArgs.msg = msg
      self._responseArgs.t = t
      self._erred = true
      while (self._errorHandlers.length > 0) {
        self._errorHandlers.shift()(resp, msg, t)
      }
      complete(resp)
    }

    this.request = getRequest.call(this, success, error)
  }

  Reqwest.prototype = {
    abort: function () {
      this._aborted = true
      this.request.abort()
    }

  , retry: function () {
      init.call(this, this.o, this.fn)
    }

    /**
     * Small deviation from the Promises A CommonJs specification
     * http://wiki.commonjs.org/wiki/Promises/A
     */

    /**
     * `then` will execute upon successful requests
     */
  , then: function (success, fail) {
      success = success || function () {}
      fail = fail || function () {}
      if (this._fulfilled) {
        this._responseArgs.resp = success(this._responseArgs.resp)
      } else if (this._erred) {
        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._fulfillmentHandlers.push(success)
        this._errorHandlers.push(fail)
      }
      return this
    }

    /**
     * `always` will execute whether the request succeeds or fails
     */
  , always: function (fn) {
      if (this._fulfilled || this._erred) {
        fn(this._responseArgs.resp)
      } else {
        this._completeHandlers.push(fn)
      }
      return this
    }

    /**
     * `fail` will execute when the request fails
     */
  , fail: function (fn) {
      if (this._erred) {
        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._errorHandlers.push(fn)
      }
      return this
    }
  , 'catch': function (fn) {
      return this.fail(fn)
    }
  }

  function reqwest(o, fn) {
    return new Reqwest(o, fn)
  }

  // normalize newline variants according to spec -> CRLF
  function normalize(s) {
    return s ? s.replace(/\r?\n/g, '\r\n') : ''
  }

  function serial(el, cb) {
    var n = el.name
      , t = el.tagName.toLowerCase()
      , optCb = function (o) {
          // IE gives value="" even where there is no value attribute
          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
          if (o && !o['disabled'])
            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
        }
      , ch, ra, val, i

    // don't serialize elements that are disabled or without a name
    if (el.disabled || !n) return

    switch (t) {
    case 'input':
      if (!/reset|button|image|file/i.test(el.type)) {
        ch = /checkbox/i.test(el.type)
        ra = /radio/i.test(el.type)
        val = el.value
        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
      }
      break
    case 'textarea':
      cb(n, normalize(el.value))
      break
    case 'select':
      if (el.type.toLowerCase() === 'select-one') {
        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
      } else {
        for (i = 0; el.length && i < el.length; i++) {
          el.options[i].selected && optCb(el.options[i])
        }
      }
      break
    }
  }

  // collect up all form elements found from the passed argument elements all
  // the way down to child elements; pass a '<form>' or form fields.
  // called with 'this'=callback to use for serial() on each element
  function eachFormElement() {
    var cb = this
      , e, i
      , serializeSubtags = function (e, tags) {
          var i, j, fa
          for (i = 0; i < tags.length; i++) {
            fa = e[byTag](tags[i])
            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
          }
        }

    for (i = 0; i < arguments.length; i++) {
      e = arguments[i]
      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
    }
  }

  // standard query string style serialization
  function serializeQueryString() {
    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
  }

  // { 'name': 'value', ... } style serialization
  function serializeHash() {
    var hash = {}
    eachFormElement.apply(function (name, value) {
      if (name in hash) {
        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
        hash[name].push(value)
      } else hash[name] = value
    }, arguments)
    return hash
  }

  // [ { name: 'name', value: 'value' }, ... ] style serialization
  reqwest.serializeArray = function () {
    var arr = []
    eachFormElement.apply(function (name, value) {
      arr.push({name: name, value: value})
    }, arguments)
    return arr
  }

  reqwest.serialize = function () {
    if (arguments.length === 0) return ''
    var opt, fn
      , args = Array.prototype.slice.call(arguments, 0)

    opt = args.pop()
    opt && opt.nodeType && args.push(opt) && (opt = null)
    opt && (opt = opt.type)

    if (opt == 'map') fn = serializeHash
    else if (opt == 'array') fn = reqwest.serializeArray
    else fn = serializeQueryString

    return fn.apply(null, args)
  }

  reqwest.toQueryString = function (o, trad) {
    var prefix, i
      , traditional = trad || false
      , s = []
      , enc = encodeURIComponent
      , add = function (key, value) {
          // If value is a function, invoke it and return its value
          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
          s[s.length] = enc(key) + '=' + enc(value)
        }
    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(o)) {
      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in o) {
        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
      }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+')
  }

  function buildParams(prefix, obj, traditional, add) {
    var name, i, v
      , rbracket = /\[\]$/

    if (isArray(obj)) {
      // Serialize array item.
      for (i = 0; obj && i < obj.length; i++) {
        v = obj[i]
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
        }
      }
    } else if (obj && obj.toString() === '[object Object]') {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }

    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  reqwest.getcallbackPrefix = function () {
    return callbackPrefix
  }

  // jQuery and Zepto compatibility, differences can be remapped here so you can call
  // .ajax.compat(options, callback)
  reqwest.compat = function (o, fn) {
    if (o) {
      o['type'] && (o['method'] = o['type']) && delete o['type']
      o['dataType'] && (o['type'] = o['dataType'])
      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
    }
    return new Reqwest(o, fn)
  }

  reqwest.ajaxSetup = function (options) {
    options = options || {}
    for (var k in options) {
      globalSetupOptions[k] = options[k]
    }
  }

  return reqwest
});


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tracking = tracking;
exports.unsupportedProductTracking = unsupportedProductTracking;

var _reqwest = __webpack_require__(11);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _jsCookie = __webpack_require__(6);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _bean = __webpack_require__(7);

var _bean2 = _interopRequireDefault(_bean);

var _utilities = __webpack_require__(2);

var _features = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// let initialBehaviouralTrackingRequestSent
// let blacklistedValues = ['select size', 'choose an option...', 'выбрать размер', 'выберите размер', 'select your fit...', 'seleziona la dimensione']
var blacklistedValues = [];

function tracking(params) {
  return {
    init: startEasySizeTracking
  };
}

function stockUpdate(params) {
  var formData = {
    product_brand: params.product.brand,
    product_gender: params.product.gender,
    product_type: params.product.category,
    product_id: params.product.id,
    product_image_url: params.product.image_url,
    product_model: params.product.model,
    product_sku: params.product.sku,
    product_fit: params.product.fit,
    product_url: window.location.href,
    stock: JSON.stringify(params.product.stock),
    shop_id: params.shop.generated_shop_id
  };

  (0, _reqwest2.default)({
    method: 'GET',
    url: params.easysize.widget_url + 'product_stock_update',
    data: formData,
    error: function error(data) {
      (0, _utilities.debug)('[EasySize debug]: Error updating stock', data);
    },
    success: function success(data) {}
  });
}

function unsupportedProductTracking(params) {
  var formData = {
    is_product_supported: false,
    brand: params.product.brand,
    gender: params.product.gender,
    type: params.product.category.join(','),
    product_id: params.product.id,
    user_id: params.shop.user_id,
    user_type: params.easysize.user_type,
    uuid: params.easysize.uuid,
    img_url: params.product.image_url,
    model: params.product.model,
    product_title: params.product.title,
    sku: params.product.sku,
    fit: params.product.fit,
    language: params.shop.language,
    stock: JSON.stringify(params.product.stock),
    product_url: window.location.href,
    shop_id: params.shop.generated_shop_id,
    uq_key: params.easysize.user_id != -1 ? params.easysize.user_id : params.easysize.uuid, // eslint-disable-line
    width: window.innerWidth,
    height: window.innerHeight,
    demo_mode: params.easysize.demo_mode,
    session_id: params.easysize.session_id,
    tags: params.shop.tags
  };

  formData.tags = JSON.stringify(formData.tags);

  (0, _reqwest2.default)({
    method: 'GET',
    url: params.easysize.tracking_url + 'analytics/init',
    data: formData,
    error: function error(data) {
      (0, _utilities.debug)('[EasySize debug]: Error initiating tracking', data);
    },
    success: function success(data) {
      if (data.hasOwnProperty('shop_sizeguide_selector')) {
        /* If sizeguide selector is present on our end, we track the clicks of that button */
        var sizeGuide = (0, _qwery2.default)(data.shop_sizeguide_selector)[0];
        if (sizeGuide) {
          _bean2.default.on(sizeGuide, 'click', function () {
            params.track(25);
          });
        }
      }

      _jsCookie2.default.set('espageview', data.pageview_id, { expires: 28, secure: true, sameSite: 'strict' });
      params.device = data.device_info;
      params.easysize.pageview_id = data.pageview_id;
      params.easysize.tracking_started = true;
    }
  });

  var track = function track(action) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!action) {
      return;
    }
    if (!params.easysize.tracking_started) {
      /* Try tracking again in one second, in case pageview is not yet set */
      setTimeout(function () {
        (0, _utilities.debug)('[EasySize debug]: Repeating tracking as no pageview is yet set');
        track(action, value);
      }, 1000);
    } else {
      if (action === 19) {
        if (blacklistedValues.indexOf(value.toLowerCase()) !== -1) {
          return;
        }
      }

      (0, _utilities.debug)('[EasySize tracking]', params.easysize.pageview_id, action, value);
      var i = document.createElement('img');
      i.setAttribute('src', 'https://tracking.easysize.me/analytics/collect?_t=' + new Date().getTime() + '&a=' + action + '&v=' + value + '&pv=' + params.easysize.pageview_id);
      document.body.appendChild(i);
      document.body.removeChild(i);

      if ([2, 4, 5, 7, 21, 22, 23, 30].indexOf(action) !== -1) {
        window.postMessage(JSON.stringify({
          'easysize_tracking': true,
          'action': action,
          'value': value
        }), '*');
      }
    }
  };

  params.track = track;
}

function startEasySizeTracking(params) {
  var formData = {
    brand: params.product.brand,
    gender: params.product.gender,
    type: params.product.category,
    product_id: params.product.id,
    user_id: params.shop.user_id,
    user_type: params.easysize.user_type,
    uuid: params.easysize.uuid,
    img_url: params.product.image_url,
    model: params.product.model,
    product_title: params.product.title,
    sku: params.product.sku,
    fit: params.product.fit,
    language: params.shop.language,
    stock: JSON.stringify(params.product.stock),
    product_url: window.location.href,
    shop_id: params.shop.generated_shop_id,
    uq_key: params.easysize.user_id != -1 ? params.easysize.user_id : params.easysize.uuid, // eslint-disable-line
    width: window.innerWidth,
    height: window.innerHeight,
    demo_mode: params.easysize.demo_mode,
    session_id: params.easysize.session_id,
    tags: params.shop.tags
  };

  if (_jsCookie2.default.get('easysize_sizefilter_applied') && params.easysize.user_type === 'r') {
    (0, _utilities.debug)('[EasySize debug]: product opened via size filter');
    formData.tags.push('size_filter');
  }

  if (_jsCookie2.default.get('es_recommended_products')) {
    var esRecommendedProducts = JSON.parse(_jsCookie2.default.get('es_recommended_products'));
    if (esRecommendedProducts.indexOf(params.product.id) !== -1) {
      esRecommendedProducts.splice(esRecommendedProducts.indexOf(params.product.id), 1);
      _jsCookie2.default.remove('es_recommended_products', '/');
      formData.tags.push('recommended_product');
    }
  }

  formData.tags = JSON.stringify(formData.tags);

  (0, _reqwest2.default)({
    method: 'GET',
    url: params.easysize.tracking_url + 'analytics/init',
    data: formData,
    error: function error(data) {
      (0, _utilities.debug)('[EasySize debug]: Error initiating tracking', data);
      params.easysize.pageview_id = params.easysize.uuid;
      params.easysize.tracking_started = true;
    },
    success: function success(data) {
      if (data.hasOwnProperty('shop_sizeguide_selector')) {
        /* If sizeguide selector is present on our end, we track the clicks of that button */
        var sizeGuide = (0, _qwery2.default)(data.shop_sizeguide_selector)[0];
        if (sizeGuide) {
          _bean2.default.on(sizeGuide, 'click', function () {
            params.track(25);
          });
        }
      }

      _jsCookie2.default.set('espageview', data.pageview_id, { expires: 28, secure: true, sameSite: 'strict' });
      params.device = data.device_info;
      params.easysize.pageview_id = data.pageview_id;
      params.easysize.tracking_started = true;
      Object.assign(params.features, data.features);

      /*
          Apply experiments needs a callback in order to load button html which needs to happen before loading easysize button
       */

      new Promise(function(resolve) { resolve(); }).then((function (require) {
        // eslint-disable-next-line no-unused-vars
        var removeSizeBot = __webpack_require__(1).applyExperiments(data, params, function () {
          _features.emitter.emit('easysize_tracking_initiated');
        });
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  });

  var track = function track(action) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!action) {
      return;
    }
    if (!params.easysize.tracking_started) {
      /* Try tracking again in one second, in case pageview is not yet set */
      setTimeout(function () {
        (0, _utilities.debug)('[EasySize debug]: Repeating tracking as no pageview is yet set');
        track(action, value);
      }, 1000);
    } else {
      if (action === 19) {
        if (blacklistedValues.indexOf(value.toLowerCase()) !== -1) {
          return;
        }
      }

      (0, _utilities.debug)('[EasySize tracking]', params.easysize.pageview_id, action, value);
      var i = document.createElement('img');
      i.setAttribute('src', 'https://tracking.easysize.me/analytics/collect?_t=' + new Date().getTime() + '&a=' + action + '&v=' + value + '&pv=' + params.easysize.pageview_id);

      document.body.appendChild(i);
      document.body.removeChild(i);

      if ([2, 4, 5, 7, 21, 22, 23, 30].indexOf(action) !== -1) {
        window.postMessage(JSON.stringify({
          'easysize_tracking': true,
          'action': action,
          'value': value
        }), '*');
      }
    }
  };

  params.track = track;

  return { track: track };
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(15);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(13)))

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preEasysize = preEasysize;

var _jsCookie = __webpack_require__(6);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _v = __webpack_require__(23);

var _v2 = _interopRequireDefault(_v);

var _utilities = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function preEasysize() {
  var params = {
    'product': {},
    'products': [],
    'shop': {},
    'device': {},
    'button': {},
    'features': {},
    'easysize': {},
    'calculated_size': {},
    'elements': {},
    'experiment': {}
  };

  window.EasySizeParametersDebug = params;
  window.EasySizeDebugEnable = _utilities.enableDebug;

  // EasySize data
  params.easysize.api_url = _jsCookie2.default.get('apiURL') ? _jsCookie2.default.get('apiURL') : 'https://api.easysize.me/v1/';
  params.easysize.widget_url = _jsCookie2.default.get('popupURL') ? _jsCookie2.default.get('popupURL') : 'https://popup.easysize.me/';
  params.easysize.qa_widget_url = _jsCookie2.default.get('qa_widget_url') ? _jsCookie2.default.get('qa_widget_url') : 'https://feedback.easysize.me/qa/';
  params.easysize.tracking_url = _jsCookie2.default.get('es_tracking_url') ? _jsCookie2.default.get('es_tracking_url') : 'https://tracking.easysize.me/';
  // params.easysize.api_url = "https://testing.easysize.me/v1/";
  // params.easysize.widget_url = "http://127.0.0.1:3000/";
  params.easysize.user_id = -1;
  params.easysize.user_type = 'n';
  params.easysize.calculated_size_proven_by = 100;
  params.easysize.tracking_started = false;

  params.easysize.external = {
    'cookies': _jsCookie2.default,
    'v4': _v2.default
  };

  var tracking = void 0;
  params.easysize.uuid = window.easysize_tracking_id || (0, _v2.default)();
  params.easysize.session_id = _jsCookie2.default.get('_shopify_s');
  params.easysize.pageview_id = params.easysize.uuid;

  /* eslint-disable camelcase */
  var easysize_user_id_received = false;
  var easysize_product_validated = false;
  var recognize_user_loaded = false;

  new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 12)).then(function (module) {
    tracking = module.tracking(params);
  });

  (0, _utilities.subscribe)('easysize_user_id_received', function () {
    (0, _utilities.debug)('[EasySize debug]: easysize_user_id_received: ', params.easysize.user_id);
    recognizeUserType(true, null);

    if (params.easysize.user_id == -1) {
      // eslint-disable-line
      /* If easysize user id was not defined, save it */
      params.easysize.user_id = params.easysize.uuid;
      __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 10)).then(function (module) {
        module.saveEasySizeUserId(params);
      });
      document.body.classList.add('easysize_new_user_infotip');
    }
  });

  __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 10)).then(function (module) {
    module.getEasySizeUserId(params);
  });

  (0, _utilities.subscribe)('easysize_product_validated', function (args) {
    (0, _utilities.debug)('[EasySize debug]: easysize_product_validated');
    recognizeUserType(null, true);
  });

  (0, _utilities.subscribe)('easysize_user_type_identified', function (user_type) {
    (0, _utilities.debug)('[EasySize debug]: easysize_user_type_identified: ', user_type);
    tracking.init(params);
  });

  (0, _utilities.subscribe)('easysize_tracking_initiated', function () {
    new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1)).then(function (module) {
      module.enableEasySizeFeatures(params);
    });
  });

  function recognizeUserType(local_easysize_product_validated, local_easysize_user_id_received) {
    if (local_easysize_product_validated) {
      easysize_product_validated = true;
    }
    if (local_easysize_user_id_received) {
      easysize_user_id_received = true;
    }

    if (easysize_product_validated && easysize_user_id_received && !recognize_user_loaded) {
      recognize_user_loaded = true;
      __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 10)).then(function (module) {
        module.recognizeUserType(params);
      });
    }
  }

  return params;
  /* eslint-enable camelcase */
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertAfter = insertAfter;
exports.selectOptionInSelect = selectOptionInSelect;

var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _bean = __webpack_require__(7);

var _bean2 = _interopRequireDefault(_bean);

var _queryString = __webpack_require__(27);

var _queryString2 = _interopRequireDefault(_queryString);

var _utilities = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function insertAfter(newNode, referenceNode) {
  /*
        Insert element after another element
         newNode - element to insert
        referenceNode - element that the new node will be appended after
     */

  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function selectOptionInSelect(selector, optionValue, params) {
  var select = (0, _qwery2.default)(selector)[0];
  var options = (0, _qwery2.default)(selector + ' option');

  for (var i = 0; i < options.length; i++) {
    if ((0, _utilities.compareStringIgnoreCase)(options[i].innerHTML, optionValue)) {
      var urlParams = _queryString2.default.parse(location.search); // eslint-disable-line

      /*
          Parse query parameters and check whether 'pre-select' parameter is present
          If yes, do not select the size, but keep the returning user message
       */
      if (!urlParams['size'] || params.easysize.opened === true) {
        select.selectedIndex = i;
        _bean2.default.fire(select, 'change');
      }
      return true;
    }
  };

  return false;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smartSizeSelection = smartSizeSelection;
exports.smartSizeSelectionVP = smartSizeSelectionVP;
function smartSizeSelection(needle, haystack) {
  // Needle equals item in haystack
  for (var i = 0; i < haystack.length; i++) {
    var item = haystack[i];
    if (needle.toLowerCase() === item.toLowerCase()) {
      return item;
    }
  };

  // Item in haystack starts with needle
  for (var _i = 0; _i < haystack.length; _i++) {
    var _item = haystack[_i];
    if (_item.toLowerCase().indexOf(needle.toLowerCase()) === 0) {
      return _item;
    }
  };

  return false;
}

function smartSizeSelectionVP(needle, haystack) {
  // Needle equals item in haystack
  // VP workaround, only select size if fully matched
  for (var i = 0; i < haystack.length; i++) {
    var item = haystack[i];
    if (needle.toLowerCase() === item.toLowerCase()) {
      return item;
    }
  };
  return false;
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSizeInsights = createSizeInsights;
/* eslint-disable */

function mapTo0To100(value) {
  // Ensure the input value is within the range [-1, 1]
  value = Math.max(-1, Math.min(1, value));

  // Map the value to the range [0, 100]
  var mappedValue = (value + 1) * 50;

  return mappedValue;
}

function createSizeInsights(conf) {
  // TODO -1 = runs bigger, +1 - runs smaller
  var settings = {
    visual: "scale", // scale|text
    size_shift: 0,

    // Translations
    texts: {
      size_down: "Runs bigger. Buy one size smaller than your regular size",
      size_half_down: "Runs slightly bigger. Buy half a size smaller than your regular size",
      size_regular: "True to size. Buy your regular size",
      size_half_up: "Runs slightly smaller. Buy half a size bigger than your regular size",
      size_up: "Runs smaller. Buy one size bigger than your regular sizes",
      // Scale text
      scale_small: "Smaller",
      scale_regular: "True to size",
      scale_large: "Bigger"
    },
    // Visual - Scale
    scale_edge_type: "line", // line|arrow
    scale_caret_type: "ball",
    scale_caret_offset_center: 7,
    scale_caret_offset_edge: 8,
    scale_breakpoints: false,
    scale_markers: false,

    // Visual - Text
    text_scale_breakdown: [{ shift: -0.7, text: 'size_down' }, { shift: -0.2, text: 'size_half_down' }, { shift: 0.2, text: 'size_regular' }, { shift: 0.7, text: 'size_half_up' }, { shift: 1, text: 'size_up' }],

    // All styling attributes
    style: {
      es_si_display: "block",
      es_si_width: "auto",
      es_si_padding: "10px 0",
      es_si_margin: "0",

      es_si_scale_background: "transparent",
      es_si_scale_bar: "gray",
      es_si_scale_edge: "gray",
      es_si_scale_font_color: "gray",
      es_si_scale_font_size: "14px",
      es_si_scale_line_height: "14px",
      es_si_scale_caret: "black",
      es_si_scale_marker_color: "black",

      es_si_txt_wrapper_background: "#e6e6e6",
      es_si_txt_align: "left",
      es_si_txt_padding: "5px 10px"
    },

    // Default placement type
    placeholder_type: "append" // append|prepend|before|after
  };

  settings = Object.assign(settings, conf);

  // If enabled, make the visual scale caret stick to one of the breakpoints
  if (settings.scale_breakpoints) {
    for (var i = 0; i < settings.scale_breakpoints.length; i++) {
      if (settings.shift <= settings.scale_breakpoints[i].shift) {
        settings.shift = settings.scale_breakpoints[i].stick;
        break;
      }
    }
  }

  // Start generating visuals
  /*
  	Get shift in 0-100 value
    0 Item is smaller
    50 - Item is true to size
    100 - Item is bigger
  */
  var shift = mapTo0To100(settings.shift * -1); // Reverse shift, replace recommendation shift into item sizing shift
  var wrapper = document.createElement("div");
  wrapper.className = "size_insights " + settings.visual;

  if (settings.visual === "scale") {
    // Build scale size insights
    var html = {
      edge: '<div class="edge <type> <side>"> </div>',
      bar: '<div class="size_insights--bar"> </div>',
      caret: '<div style="left: calc(<position>% - <center_position>px)" class="size_insights--caret <type>"> </div>',
      marker: '<div style="left: calc(<position>%)" data-pos="<shift>" class="size_insights--marker <show> <size>"> </div>',
      content: '<div class="size_insights--content <side>"><text></div>'
    };

    // Offset caret position
    var caret_pos = settings.scale_caret_offset_edge / 2 + shift / 100 * (100 - settings.scale_caret_offset_edge);

    // HTML generation
    wrapper.innerHTML = "\n      " + html.edge.replace("<side>", "left").replace("<type>", settings.scale_edge_type) + "\n      " + html.edge.replace("<side>", "right").replace("<type>", settings.scale_edge_type) + "\n      " + html.bar + "\n      " + html.caret.replace("<type>", settings.scale_caret_type).replace("<position>", caret_pos).replace("<center_position>", settings.scale_caret_offset_center) + "\n      " + html.content.replace("<side>", "left").replace("<text>", settings.texts.scale_small) + "\n      " + html.content.replace("<side>", "").replace("<text>", settings.texts.scale_regular) + "\n      " + html.content.replace("<side>", "right").replace("<text>", settings.texts.scale_large) + "\n    ";

    if (settings.scale_markers) {
      for (var _i = 0; _i < settings.scale_markers.length; _i++) {
        var marker_shift = mapTo0To100(settings.scale_markers[_i].shift);
        var marker_pos = settings.scale_caret_offset / 2 + marker_shift / 100 * (100 - settings.scale_caret_offset);
        wrapper.innerHTML += html.marker.replace('<position>', marker_pos).replace('<shift>', settings.scale_markers[_i].shift).replace('<size>', settings.scale_markers[_i].size).replace('<show>', settings.scale_markers[_i].show ? 'show' : '') + "\n        ";
      }
    }
  } else {
    var _html = {
      text_wrapper: '<div class="size_insights--text-wrapper"><text></div>'
    };
    var text = settings.texts[settings.text_scale_breakdown[settings.text_scale_breakdown.length - 1].text];

    for (var _i2 = 0; _i2 < settings.text_scale_breakdown.length; _i2++) {
      if (settings.shift <= settings.text_scale_breakdown[_i2].shift && settings.texts[settings.text_scale_breakdown[_i2].text]) {
        text = settings.texts[settings.text_scale_breakdown[_i2].text];
        break;
      }
    }

    /*
    -1 | 0 | We recommend smaller size, so person should size up
    0 | 50 | True to size
    1 | 100 | We recommend bigger size, so person should size down
    */

    if (text) {
      wrapper.innerHTML = "\n        " + _html.text_wrapper.replace("<text>", text) + "\n      ";
    }
  }

  // Apply custom styling
  var r = document.querySelector(":root");
  function set_root_css_variable(variable, value) {
    wrapper.style.setProperty("--" + variable, value);
  }

  Object.keys(settings.style).forEach(function (key) {
    set_root_css_variable(key, settings.style[key]);
  });

  var placeholder = document.querySelector(settings.placeholder);
  if (placeholder) {
    placeholder[settings.placeholder_type](wrapper);
  }
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventHandler = eventHandler;

var _vertebrateEventEmitter = __webpack_require__(31);

var _vertebrateEventEmitter2 = _interopRequireDefault(_vertebrateEventEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function eventHandler() {
  var emitter = (0, _vertebrateEventEmitter2.default)({});

  return emitter;
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _bean = __webpack_require__(7);

var _bean2 = _interopRequireDefault(_bean);

var _easysizePreStart = __webpack_require__(17);

var _features = __webpack_require__(1);

var _utilities = __webpack_require__(2);

__webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  if (window.EasysizeWrapperInitiated) {
    return;
  }

  window.EasysizeWrapperInitiated = true;
  var params = (0, _easysizePreStart.preEasysize)();

  window.EasySize = function (opts) {
    return {
      start: function start() {
        __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 34)).then(function (module) {
          var es = module.EasySize(opts, params); // eslint-disable-line
          es.start();

          window.EasySize = function (opts) {
            return module.EasySize(opts);
          };
        });
      },
      sizeChangedTo: function sizeChangedTo(size) {
        _features.emitter.emit('easysize_size_selected', size);
        params.shop.selected_size = size;
      },
      embed: function embed(config) {
        if (params.product.supported) {
          new Promise(function(resolve) { resolve(); }).then((function (require) {
            __webpack_require__(0).embed(params, config);
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
          console.warn('[Easysize] trying to open widget when product is not supported');
        }
      },
      update_product: function update_product(config) {
        params.product = Object.assign(params.product, config);
      },
      open: function open(config) {
        // Prevent widget from being opened multiple times
        if (document.getElementById('easysize_popup')) {
          return;
        }

        params.shop.custom_css = config.custom_css || params.shop.custom_css;

        if (params.product.supported) {
          new Promise(function(resolve) { resolve(); }).then((function (require) {
            __webpack_require__(0).startQaAdvisor(params);
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
          console.warn('[Easysize] trying to open widget when product is not supported');
        }
      },
      refresh: function refresh() {
        (0, _utilities.removeElementsByClassName)('es-selected');
        (0, _utilities.removeElementsByClassName)('es-recommended');
        (0, _utilities.removeElementsByClassName)('easysize_button');
        (0, _utilities.removeElementsById)('esid-input');

        document.body.classList.remove('es-recommended-size');
        document.body.classList.remove('es-selected-size');
        document.body.classList.remove('es-loaded');

        params.elements.add_to_cart_button = (0, _qwery2.default)(params.shop.add_to_cart_btn_selector)[0];
        params.elements.button_placeholder = (0, _qwery2.default)(params.shop.easysize_button_placeholder_selector.constructor === Array ? params.shop.easysize_button_placeholder_selector[0] : params.shop.easysize_button_placeholder_selector)[0];
        params.elements.size_dropdown = (0, _qwery2.default)(params.shop.size_dropdown_selector)[0];

        if (params.product.brand_id) {
          (0, _features.loadEasySizeButton)(params);
          if (params.easysize.calculated_size) {
            _features.emitter.emit('easysize-size-selected');
          }
        }
      },
      preselectSize: function preselectSize() {
        if (params.easysize.calculated_size) {
          params.shop.update_size_dropdown(params.easysize.calculated_size, params);
          _features.emitter.emit('easysize-size-selected');
        }
      },
      isLoaded: function isLoaded() {
        return params.easysize.is_loaded;
      },
      setLanguage: function setLanguage(language) {
        (0, _features.setLanguage)(params, language);
      }
    };
  };

  window.dispatchEvent(new Event('easysize_ready', { 'bubbles': true, 'cancelable': false }));
})();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(24);
var bytesToUuid = __webpack_require__(25);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(28);
var objectAssign = __webpack_require__(29);
var decodeComponent = __webpack_require__(30);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// EventReference instances are keys, and objects with information about a
// callback are values.
var allHandlersPrivateData = new WeakMap();

function useCallback(emitter, eventReference, args) {
  var privateData = allHandlersPrivateData.get(eventReference);

  privateData.callback.apply(emitter, args);
  privateData.count--;

  return privateData.count === 0;
}

function getEventName(EventReference) {
  return allHandlersPrivateData.get(EventReference).eventName;
}

// EventReference instances are used as keys to get information about event
// callbacks. An event can also be cancelled with an EventReference instance.
function EventReference(eventName, callback, count) {
  allHandlersPrivateData.set(this, { eventName: eventName, callback: callback, count: count });
}

// This WeapMap instance has EventEmitter instances as keys, and Map instances
// as values. The Map instances have event names as keys, and Set instances as
// values. The Set instance associated with an event name contains all the
// EventHandler instances associated with the event with that name for that
// emitter.
var allEventsForAllEmitters = new WeakMap();

function checkArgs(eventName, callback, count) {
  if (typeof eventName !== 'string') {
    throw new TypeError('Event name must be a string.');
  }

  if (typeof callback !== 'function') {
    throw new TypeError('Callback must be a function.');
  }

  if (typeof count !== 'number') {
    throw new TypeError('When given, count must be a number.');
  }

  if (count !== Infinity && (Math.floor(count) !== count || count < 1)) {
    throw new RangeError('Count must not be set to an integer less than zero or a non-integer.');
  }
}

function EventEmitter() {
  if (!(this instanceof EventEmitter)) {
    return new EventEmitter();
  }

  allEventsForAllEmitters.set(this, new Map());
}

EventEmitter.prototype.on = function (eventName, callback, uncheckedCount) {
  var count = uncheckedCount === undefined ? Infinity : uncheckedCount;

  checkArgs(eventName, callback, count);

  var allEventsForThisEmitter = allEventsForAllEmitters.get(this);
  var allEventsForThisEventName = allEventsForThisEmitter.get(eventName);
  var eventReference = new EventReference(eventName, callback, count);

  if (!allEventsForThisEventName) {
    allEventsForThisEventName = new Set();
    allEventsForThisEmitter.set(eventName, allEventsForThisEventName);
  }

  allEventsForThisEventName.add(eventReference);

  return eventReference;
};

EventEmitter.prototype.off = function (handler) {
  var eventName = getEventName(handler);
  var allEventsForThisEmitter = allEventsForAllEmitters.get(this);
  var allEventsForThisEventName = allEventsForThisEmitter.get(eventName);

  if (allEventsForThisEventName) {
    allEventsForThisEventName.delete(handler);
  }
};

EventEmitter.prototype.trigger = function (eventName) {
  var allEventsForThisEmitter = allEventsForAllEmitters.get(this);
  var allEventsForThisEventName = allEventsForThisEmitter.get(eventName) || [];
  var args = Array.prototype.slice.call(arguments, 1);
  var emitter = this;

  allEventsForThisEventName.forEach(function (eventReference) {
    var done = useCallback(emitter, eventReference, args);

    if (done) {
      allEventsForThisEventName.delete(eventReference);
    }
  });
};

EventEmitter.prototype.emit = EventEmitter.prototype.trigger;

EventEmitter.prototype.allOff = function (eventName) {
  var allEventsForThisEmitter = allEventsForAllEmitters.get(this);

  if (typeof eventName === 'string') {
    allEventsForThisEmitter.delete(eventName);
  } else {
    allEventsForThisEmitter.clear();
  }
};

// The production build only needs the EventEmitter constructor, but the tests need both the

/* harmony default export */ __webpack_exports__["default"] = (EventEmitter);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);


var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */];
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14).setImmediate))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// easysize.js